import { uploadSurveyorFile } from './utils/surveyorUpload';
import { dispatchError } from './dispatchUi';
import axios from 'axios';
import Cookies from "js-cookie";
import { getAuthToken } from "./auth";
import { normalizeApiError } from "./utils/apiError";
// import { importPKCS8, SignJWT } from 'jose';
export const APIExportDealContacts = async (token) => {
  const response = await axios.get(`${API_URL}/bitrix/export-contacts/`, {
    ...getAuthConfig(token), responseType: 'blob',
  });
  return response.data;
};

export const API_URL = 'https://api.planium.tech'
export const WSS_URL = 'wss://api.planium.tech'

// export const API_URL = 'http://127.0.0.1:8000'
// export const WSS_URL = 'ws://127.0.0.1:8000'


// ── Глобально докладываем Bearer-токен во все запросы, если он не задан явно ──
// Чинит класс багов, когда отдельные функции не передавали токен (401 Invalid token /
// Authorization: Bearer null). Явно переданный getAuthConfig(token) остаётся в приоритете.
axios.interceptors.request.use((config) => {
    try {
        const url = (config.baseURL || '') + (config.url || '');
        // Токен подставляем только на наш API (чужие домены не трогаем)
        const isOurApi = url.includes(API_URL) || url.startsWith('/');
        if (!isOurApi) return config;

        config.headers = config.headers || {};
        const current = config.headers.Authorization || config.headers.authorization;
        const isBad = !current
            || current === 'Bearer null'
            || current === 'Bearer undefined'
            || current === 'Bearer ';

        if (isBad) {
            const token = getAuthToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            } else {
                // токена нет — убираем «мусорный» заголовок, чтобы не слать Bearer null
                delete config.headers.Authorization;
                delete config.headers.authorization;
            }
        }
    } catch (e) {
        // интерцептор не должен ломать запрос
        console.warn('[axios auth interceptor]', e);
    }
    return config;
});


const API_GET_EVENTS = '/main/api/events/'
// Запрос событий
export const APIGetEvents = async (state, employee_id, start_date = null, end_date = null, light = false) => {
  try {
    var params = {}
    if (employee_id) {
        params.employee_id = employee_id
    }
    if (state) {
        params.state = state
    }
    if (start_date) {
        params.start_date = start_date
    }
    if (end_date) {
        params.end_date = end_date
    }
    if (light) {
        params.light = 1
    }
    
    const response = await axios.get(API_URL + API_GET_EVENTS, { params: params });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

export const APIGetEventsPaginated = async ({
    state = null,
    employee_id = null,
    start_date = null,
    end_date = null,
    page = 1,
    page_size = 30,
}) => {
    try {
        const params = { paginated: 1, page, page_size };
        if (state) params.state = state;
        if (employee_id) params.employee_id = employee_id;
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;

        const response = await axios.get(API_URL + API_GET_EVENTS, { params });
        return response.data; // { results, page, pages, count, has_next }
    } catch (error) {
        console.error('APIGetEventsPaginated:', error);
        return { results: [], page: 1, pages: 1, count: 0, has_next: false };
    }
};

const API_GET_DRAFTSMAN_EVENTS = '/main/api/draftsman/events/';

export const APIGetDraftsmanEvents = async ({
    employee_id,
    filter = 'mine_active',
    page = 1,
    page_size = 10,
    q_status,
}) => {
    try {
        const params = { employee_id, filter, page, page_size };
        if (q_status) params.q_status = q_status;
        const response = await axios.get(API_URL + API_GET_DRAFTSMAN_EVENTS, { params });
        return response.data;
        // { results, page, pages, count, has_next, counts:{mine_active, mine_completed, free} }
    } catch (error) {
        console.error('APIGetDraftsmanEvents:', error);
        return {
            results: [], page: 1, pages: 1, count: 0, has_next: false,
            counts: { mine_active: 0, mine_completed: 0, free: 0, others: 0 },
        };
    }
};

// Ошибка остаётся ошибкой: интерфейс не показывает её как пустую выдачу.
export const APIGetDraftsmanWorkspace = async (params, signal) => {
    const response = await axios.get(API_URL + API_GET_DRAFTSMAN_EVENTS, {
        params: { ...params, workspace: '1', page_size: 12 }, signal,
    });
    return response.data;
};

// ── Оценка отделом качества работы чертёжника по событию ──
const API_DRAFTSMAN_QUALITY_REVIEW = '/data-statistic/api/events/'; // + `${eventId}/quality-review/`

// Прочитать текущую оценку события (или { review: null }).
export const APIGetDraftsmanQualityReview = async (eventId) => {
    try {
        const response = await axios.get(
            API_URL + API_DRAFTSMAN_QUALITY_REVIEW + `${eventId}/quality-review/`
        );
        return response.data; // { review: null | {...} }
    } catch (error) {
        console.error('APIGetDraftsmanQualityReview:', error);
        return { review: null };
    }
};

// Создать/обновить оценку. Ошибки НЕ гасим — панель должна показать текст 400
// (например «комментарий обязателен при оценке ниже 5»).
export const APISaveDraftsmanQualityReview = async (eventId, { score, comment }) => {
    const response = await axios.post(
        API_URL + API_DRAFTSMAN_QUALITY_REVIEW + `${eventId}/quality-review/`,
        { score, comment: comment || '' }
    );
    return response.data; // { review: {...} }
};

export const APIGetOverdueEvents = async (token) => {
    try {
        const response = await axios.get(API_URL + '/main/api/surveyor/events/overdue/', getAuthConfig(token));
        return response.data;
    } catch (e) {
        return null;
    }
};

export const APISurveyorTakeEvent = async (eventId, token) => {
    try {
        const response = await axios.post(
            `${API_URL}/main/api/surveyor/events/${eventId}/take/`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (e) {
        return e?.response?.data || null;
    }
};

const API_SEARCH_DEALS = '/main/api/search-deals/'
// Запрос поиска сделок с пагинацией
export const APISearchDeals = async (search = '', page = 1, pageSize = 500) => {
  try {
    const response = await axios.get(API_URL + API_SEARCH_DEALS, {
      params: {
        search: search,
        page: page,
        page_size: pageSize
      }
    });
    return response.data;
  } catch (error) {
    console.log('Ошибка поиска сделок:', error);
    return { deals: [], has_more: false, current_page: page };
  }
};

const API_GET_EVENTS_SEARCH = '/main/api/events/'
// Обновленный запрос событий с поиском
export const APIGetEventsSearch = async (state, employee_id, start_date = null, end_date = null, search = '') => {
  try {
    var params = {}
    if (employee_id) {
        params.employee_id = employee_id
    }
    if (state) {
        params.state = state
    }
    if (start_date) {
        params.start_date = start_date
    }
    if (end_date) {
        params.end_date = end_date
    }
    if (search) {
        params.search = search
    }
    
    const response = await axios.get(API_URL + API_GET_EVENTS_SEARCH, { params: params });
    return response.data;
  } catch (error) {
    console.log('Ошибка загрузки событий:', error);
    return [];
  }
};


const API_GET_EMPLOYEES_LIST = '/main/api/employee-list/'
// Запрос сотрудников
export const APIGetEmployeesList = async (token) => {
  try {
    const response = await axios.get(API_URL + API_GET_EMPLOYEES_LIST, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_GET_EMPLOYEES_PAGINATED = '/main/api/employee-all-paginated/';

export const APIGetEmployeesPaginated = async (token, params = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set('page', params.page);
  if (params.page_size) query.set('page_size', params.page_size);
  // .trim() — чтобы пробельный поиск не уходил на бэк и не ломал индекс
  if (params.search && String(params.search).trim()) {
    query.set('search', String(params.search).trim());
  }
  if (params.position) query.set('position', params.position);
  if (params.city) query.set('city', params.city);
  if (params.status) query.set('status', params.status);
  if (params.no_coverage) query.set('no_coverage', params.no_coverage);

  const url = `${API_URL}${API_GET_EMPLOYEES_PAGINATED}?${query.toString()}`;

  try {
    const config = {
      ...getAuthConfig(token),
      signal: params.signal,
    };
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    // Отмену пробрасываем наверх, чтобы loadEmployees умел её отличить
    if (axios.isCancel?.(error) || error?.name === 'CanceledError' || error?.name === 'AbortError') {
      throw error;
    }
    console.error('Ошибка загрузки сотрудников:', error);
    return null;
  }
};

const API_GET_EMPLOYEES_ALL = '/main/api/employee-all/'
const API_GET_EMPLOYEE_CHOICES = '/main/api/employee-choices/'

// Справочник исполнителей для выпадающих списков.
// Отдельная ручка от employee-all: та закрыта правом «просмотр раздела
// Исполнители», которого у менеджера по качеству нет, — и все списки выбора
// исполнителя у него молча оказывались пустыми. Здесь права не нужны, но и
// данных меньше: ни телефона, ни почты.
// position — 'draftsman', 'surveyor' или несколько через запятую; null — все.
export const APIGetEmployeeChoices = async (token, position = null) => {
  try {
    const params = {};
    if (position) params.position = position;
    const response = await axios.get(API_URL + API_GET_EMPLOYEE_CHOICES, {
      ...getAuthConfig(token),
      params,
    });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error('APIGetEmployeeChoices:', error);
    return [];
  }
};

// Запрос сотрудников (Всех)
export const APIGetEmployeesAll = async (token) => {
  try {
    const response = await axios.get(API_URL + API_GET_EMPLOYEES_ALL, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};


const API_CREATE_EMPLOYEE = '/main/api/employees/create/'
// Запрос создания сотрудника
export const APICreateEmployee = async (data, token) => {
  try {
    const response = await axios.post(API_URL + API_CREATE_EMPLOYEE, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    // Возвращаем данные ответа сервера, чтобы фронт мог разобрать поля с ошибками
    if (error.response && error.response.data) {
      return { status: 'error', ...error.response.data };
    }
    return { status: 'error', message: error.message || 'Ошибка сети' };
  }
};

const API_UPDATE_EMPLOYEE = '/main/api/employees/'
// Запрос обновления сотрудника
export const APIUpdateEmployee = async (id, data, token) => {
  try {
    const response = await axios.patch(API_URL + API_UPDATE_EMPLOYEE + `${id}/update/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response && error.response.data) {
      return { status: 'error', ...error.response.data };
    }
    return { status: 'error', message: error.message || 'Ошибка сети' };
  }
};

const API_DELETE_EMPLOYEE = '/main/api/employees/'
// Запрос удаления сотрудника
export const APIDeleteEmployee = async (id, token) => {
  try {
    const response = await axios.delete(API_URL + API_DELETE_EMPLOYEE + `${id}/delete/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const API_GET_EMPLOYEE_EVENTS = '/main/api/employees/'

// Запрос получения событий сотрудника с пагинацией
export const APIGetEmployeeEvents = async (employeeId, page = 1, pageSize = 20, token) => {
  try {
    const response = await axios.get(
      API_URL + API_GET_EMPLOYEE_EVENTS + `${employeeId}/events/`, 
      {
        ...getAuthConfig(token),
        params: { 
          page: page,
          page_size: pageSize // Добавляем параметр размера страницы
        }
      }
    );
    return response.data;
  } catch (error) {
    console.log("Ошибка при загрузке событий сотрудника:", error);
    return error;
  }
};

const API_BLOCK_UNBLOCK_EMPLOYEE = '/main/api/employees/'

// Блокировка/разблокировка сотрудника
export const APIBlockUnblockEmployee = async (employeeId, action = 'toggle', token) => {
  try {
    const response = await axios.patch(
      API_URL + API_BLOCK_UNBLOCK_EMPLOYEE + `${employeeId}/block/`,
      { action: action },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log("Ошибка при блокировке/разблокировке сотрудника:", error);
    return { status: 'error', message: 'Ошибка при выполнении действия' };
  }
};

// Анкеты на проверке (неподтверждённые)
export const APIGetPendingRegistrations = async (token) => {
  try {
    const response = await axios.get(
      API_URL + '/main/api/employees/pending/',
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log("Ошибка получения анкет на проверке:", error);
    return { results: [] };
  }
};

// Подтвердить анкету (выдать доступ)
export const APIApproveRegistration = async (employeeId, token) => {
  try {
    const response = await axios.post(
      API_URL + `/main/api/employees/${employeeId}/approve/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log("Ошибка подтверждения анкеты:", error);
    return { status: 'error' };
  }
};

// Отклонить анкету
export const APIRejectRegistration = async (employeeId, token) => {
  try {
    const response = await axios.post(
      API_URL + `/main/api/employees/${employeeId}/reject/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log("Ошибка отклонения анкеты:", error);
    return { status: 'error' };
  }
};


const API_GET_EMPLOYEE_DETAIL = '/main/api/employees/'

// Запрос получения детальной информации о сотруднике (со статистикой)
export const APIGetEmployeeDetail = async (employeeId, token) => {
  try {
    const response = await axios.get(
      API_URL + API_GET_EMPLOYEE_DETAIL + `${employeeId}/detail/`, 
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log("Ошибка при загрузке детальной информации сотрудника:", error);
    return error;
  }
};

// Статистика рейтинга исполнителя (детальная карточка): роль-зависимо.
export const APIGetEmployeeRatingStats = async (employeeId, token) => {
  try {
    const response = await axios.get(
      `${API_URL}/main/api/employees/${employeeId}/rating-stats/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log("Ошибка при загрузке рейтинга исполнителя:", error);
    return error;
  }
};

const API_GET_EMPLOYEE_STATISTICS = '/main/api/employees/'

// Запрос получения статистики сотрудника
export const APIGetEmployeeStatistics = async (employeeId, token) => {
  try {
    const response = await axios.get(API_URL + API_GET_EMPLOYEE_STATISTICS + `${employeeId}/detail/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const API_GET_TIMEZONES = '/main/api/timezones/'
// Запрос получения часовых поясов
export const APIGetTimezones = async () => {
  try {
    const response = await axios.get(API_URL + API_GET_TIMEZONES);
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};




const API_GET_LIST_DEAL = '/bitrix/get-birtrix-list-deal/'
// Запрос Сделок
export const APIGetListDeal = async (page = 1, pageSize = 500) => {
  try {
    const response = await axios.get(API_URL + API_GET_LIST_DEAL, {
      params: {
        page: page,
        page_size: pageSize
      }
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_GET_DEAL = '/bitrix/get-birtrix-deal/'
// Запрос Сделок
export const APIGetDeal = async (dealId) => {
  try {
    const response = await axios.get(API_URL + API_GET_DEAL, {
      params: {
        deal_id: dealId
      }
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};



const API_GET_PROGRAMS = '/bitrix/get-birtrix-programs/'
// Запрос программ
export const APIGetPrograms = async () => {
  try {
    const response = await axios.get(API_URL + API_GET_PROGRAMS);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_GET_CITYS = '/bitrix/get-birtrix-citys/'
// Запрос городов
export const APIGetCitys = async () => {
  try {
    const response = await axios.get(API_URL + API_GET_CITYS);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};



const API_UPDATE_BITRIX_FIELDS_PROGRAMS = '/bitrix/update-bitrix-deal/'
// Запрос обновления полей в битрикс
export const APIUpdateBitrixFields = async (data, token) => {
  try {
    const response = await axios.post(API_URL + API_UPDATE_BITRIX_FIELDS_PROGRAMS, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_GET_REGIONS = '/bitrix/api/regions/';
// Получение списка регионов
export const APIGetRegions = async (page = 1, pageSize = 50, token) => {
  try {
    const response = await axios.get(API_URL + API_GET_REGIONS, {
      params: {
        page: page,
        page_size: pageSize
      },
      ...getAuthConfig(token)
    });
    return response.data;
  } catch (error) {
    console.log("Ошибка при загрузке регионов:", error);
    return { regions: [], pagination: {} };
  }
};

const API_GET_REGION_WITH_CITIES = '/bitrix/api/regions/';
// Получение региона с городами
export const APIGetRegionWithCities = async (regionId, token) => {
  try {
    const response = await axios.get(API_URL + API_GET_REGION_WITH_CITIES + `${regionId}/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log("Ошибка при загрузке региона:", error);
    return { status: 'error', message: 'Ошибка загрузки' };
  }
};

const API_CREATE_UPDATE_REGION = '/bitrix/api/regions/create-update/';
// Создание или обновление региона
export const APICreateOrUpdateRegion = async (regionData, token) => {
  try {
    const response = await axios.post(API_URL + API_CREATE_UPDATE_REGION, regionData, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log("Ошибка при сохранении региона:", error);
    return { status: 'error', message: 'Ошибка сохранения' };
  }
};

const API_DELETE_REGION = '/bitrix/api/regions/';
// Удаление региона
export const APIDeleteRegion = async (regionId, token) => {
  try {
    const response = await axios.delete(
      API_URL + API_DELETE_REGION + `${regionId}/delete/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log("Ошибка при удалении региона:", error);
    return { status: 'error', message: 'Ошибка удаления региона' };
  }
};

const API_ASSIGN_CITY_TO_REGION = '/bitrix/api/regions/assign-city/';
// Привязка города к региону
export const APIAssignCityToRegion = async (data, token) => {
  try {
    const response = await axios.post(API_URL + API_ASSIGN_CITY_TO_REGION, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log("Ошибка при привязке города:", error);
    return { status: 'error', message: 'Ошибка привязки' };
  }
};

// Добавляем API функцию для отвязки города от региона
const API_UNASSIGN_CITY_FROM_REGION = '/bitrix/api/regions/unassign-city/';
// Отвязка города от региона
export const APIUnassignCityFromRegion = async (cityId, token) => {
  try {
    const response = await axios.post(
      API_URL + API_UNASSIGN_CITY_FROM_REGION,
      { city_id: cityId },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log("Ошибка при отвязке города:", error);
    return { status: 'error', message: 'Ошибка отвязки' };
  }
};

const API_GET_CITIES_WITHOUT_REGION = '/bitrix/api/regions/cities-without-region/';
// Получение городов без региона
export const APIGetCitiesWithoutRegion = async (token) => {
  try {
    const response = await axios.get(API_URL + API_GET_CITIES_WITHOUT_REGION, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log("Ошибка при загрузке городов без региона:", error);
    return { status: 'error', cities: [] };
  }
};





const API_CREATE_EVENT = '/main/api/create-event/'
// Запрос создания события
export const APICreateEvent = async (data, token) => {
  try {
    const response = await axios.post(API_URL + API_CREATE_EVENT, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};



const API_UPDATE_EVENT = '/main/api/update-event'
// Запрос обновление события
export const APIUpdateEvent = async (data, id, token) => {
  try {
    const response = await axios.patch(API_URL + API_UPDATE_EVENT + `/${id}/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};


export async function APISaveComment(eventId, comment, token) {
    try {
        const response = await axios.post(
            API_URL + `/main/api/surveyor/events/${eventId}/save-comment/`,
            { comment, confirmed: true },
            { ...getAuthConfig(token) }
        );
        return response.data;
    } catch (e) {
        return { status: 'error' };
    }
}


export async function APIGetCommentDraft(eventId, token) {
    try {
        const response = await axios.get(
            API_URL + `/main/api/surveyor/events/${eventId}/save-comment/`, getAuthConfig(token));
        return response.data;
    } catch { return null; }
}

// ════════════════════════════════════════════════════════
//  Заявки клиентов (менеджерские эндпоинты)
// ════════════════════════════════════════════════════════

const API_MANAGER_APPLICATIONS = '/main/api/client/manager/applications/'

// Список заявок клиентов для менеджера
// params: { status, has_event, search, limit, offset }
export const APIGetManagerApplications = async (params = {}, token) => {
    try {
        const response = await axios.get(API_URL + API_MANAGER_APPLICATIONS, {
            ...getAuthConfig(token),
            params,
        });
        return response.data;
    } catch (error) {
        console.error('APIGetManagerApplications error:', error?.message);
        return null;
    }
};

// Повторная попытка создать сделку Битрикс у заявки (идемпотентно).
// POST /main/api/client/manager/applications/<id>/retry-deal/
export const APIRetryApplicationDeal = async (id, token) => {
    try {
        const response = await axios.post(
            API_URL + API_MANAGER_APPLICATIONS + `${id}/retry-deal/`,
            {},
            getAuthConfig(token),
        );
        return response.data;   // { status:'ok', bitrix_deal, application } | { status:'error', detail }
    } catch (error) {
        const d = error?.response?.data || {};
        return { status: 'error', detail: d.detail || 'Не удалось создать сделку' };
    }
};

// Подробности по одной заявке
export const APIGetApplicationDetail = async (id, token) => {
    try {
        const response = await axios.get(
            API_URL + API_MANAGER_APPLICATIONS + `${id}/`,
            getAuthConfig(token),
        );
        return response.data;
    } catch (error) {
        console.error('APIGetApplicationDetail error:', error?.message);
        return null;
    }
};

// Счётчик незакреплённых заявок (для бейджа на кнопке-сворачивателе)
export const APIGetUnassignedApplicationsCount = async (token) => {
    try {
        const response = await axios.get(
            API_URL + API_MANAGER_APPLICATIONS + 'unassigned-count/',
            getAuthConfig(token),
        );
        return response.data?.count ?? 0;
    } catch (error) {
        console.error('APIGetUnassignedApplicationsCount error:', error?.message);
        return 0;
    }
};

export const APIDeleteClientApplication = async (id, token) => {
    try {
        const response = await axios.delete(API_URL + API_MANAGER_APPLICATIONS + `${id}/delete/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        console.error('APIDeleteClientApplication error:', error?.message);
        throw error;
    }
};

export const APIHideClientApplication = async (id, token) => {
    try {
        const response = await axios.patch(
            API_URL + API_MANAGER_APPLICATIONS + `${id}/hide/`,
            {},
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIHideClientApplication error:', error?.message);
        throw error;
    }
};

// Удалить СВОЙ черновик (менеджер). Только для заявок в статусе 'draft'.
// DELETE /main/api/client/manager/applications/<id>/discard-draft/
export const APIDiscardDraft = async (id, token) => {
    try {
        const response = await axios.delete(
            API_URL + API_MANAGER_APPLICATIONS + `${id}/discard-draft/`,
            getAuthConfig(token),
        );
        return response.data;   // { status:'ok', deleted:true } | { status:'error', detail }
    } catch (error) {
        console.error('APIDiscardDraft error:', error?.message);
        throw error;
    }
};

// Пометить изменения заявки как просмотренные (сбросить чип «Изменено»)
export const APIMarkApplicationSeen = async (id, token) => {
    try {
        const response = await axios.post(
            API_URL + API_MANAGER_APPLICATIONS + `${id}/mark-seen/`,
            {},
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIMarkApplicationSeen error:', error?.message);
        return null;
    }
};

// Создать заявку менеджером (Этап 1)
export const APICreateManagerApplication = async (payload, token) => {
    const response = await axios.post(
        API_URL + API_MANAGER_APPLICATIONS + 'create/',
        payload,
        getAuthConfig(token),
    );
    return response.data;
};

// Редактировать заявку менеджером (Этап 1)
export const APIUpdateManagerApplication = async (id, payload, token) => {
    const response = await axios.patch(
        API_URL + API_MANAGER_APPLICATIONS + `${id}/update/`,
        payload,
        getAuthConfig(token),
    );
    return response.data;
};

// Финализировать черновик («Создать») (Этап 2)
// Ошибку намеренно пробрасываем наверх: ModalApplication разбирает её
// через parseApiError и показывает pipeline_error из тела ответа.
export const APIFinalizeManagerApplication = async (id, token, ownerData = {}) => {
    const response = await axios.post(
        API_URL + API_MANAGER_APPLICATIONS + `${id}/finalize/`,
        ownerData,
        getAuthConfig(token),
    );
    return response.data;
};

// ── Коммерческая часть заявки ──
// Предпросмотр стоимости: клиентская цена + ЗП обмерщика + выезд одним запросом.
// Принимает либо { application_id }, либо сырые данные формы.
export const APIApplicationPricePreview = async (data, token) => {
    try {
        const r = await axios.post(
            API_URL + API_MANAGER_APPLICATIONS + 'price-preview/',
            data,
            getAuthConfig(token),
        );
        return r.data; // { client_total, client_breakdown, surveyor_salary, transfer }
    } catch (e) {
        console.error('APIApplicationPricePreview', e);
        return null;
    }
};

// Правка услуг, допов, скидок и километража у существующей заявки.
// Для заявки с созданным событием сервер вернёт 409.
export const APIApplicationCommerce = async (id, data, token) => {
    try {
        const r = await axios.patch(
            API_URL + API_MANAGER_APPLICATIONS + `${id}/commerce/`,
            data,
            getAuthConfig(token),
        );
        return r.data;
    } catch (e) {
        return {
            error: e?.response?.data?.detail || 'Не удалось сохранить коммерческую часть',
            locked: e?.response?.status === 409,
        };
    }
};

// Импорт заявок из Excel (Этап 4)
export const APIImportManagerApplications = async (file, token) => {
    const fd = new FormData();
    fd.append('file', file);
    const response = await axios.post(
        API_URL + API_MANAGER_APPLICATIONS + 'import/',
        fd,
        { headers: { Authorization: `Bearer ${token}` } },
    );
    return response.data;
};

// Скачать шаблон импорта (менеджер) — возвращает Blob
export const APIGetImportTemplate = async (token) => {
    const url = API_URL + API_MANAGER_APPLICATIONS.replace('applications/', 'import-template/');
    const response = await axios.get(url, { ...getAuthConfig(token), responseType: 'blob' });
    return response.data;
};

// Подсказки адресов (DaData suggest/address) для автодополнения
export const APISuggestAddress = async (query, token) => {
    const url = API_URL + API_MANAGER_APPLICATIONS.replace('applications/', 'suggest-address/');
    const response = await axios.post(url, { query }, getAuthConfig(token));
    return response.data;
};

// Автоопределение города по адресу ИЛИ геолокации (менеджер).
// payload: { address } ИЛИ { latitude, longitude }.
// Возвращает { city_id, city_name, matched, source, latitude, longitude, message }.
export const APIManagerDetectCity = async (payload, token) => {
    const url = API_URL + API_MANAGER_APPLICATIONS.replace('applications/', 'detect-city/');
    const response = await axios.post(url, payload || {}, getAuthConfig(token));
    return response.data;
};

// Загрузка вводного файла к заявке (менеджер)
export const APIManagerUploadApplicationFile = async (id, file, token, options = {}) => {
    const fd = new FormData();
    fd.append('file', file);
    if (options.uploadId) fd.append('edit_upload_id', options.uploadId);
    if (options.draftOnly) fd.append('draft_only', 'true');
    const url = API_URL + API_MANAGER_APPLICATIONS + `${id}/upload-file/`;
    const response = await axios.post(url, fd, { headers: { Authorization: `Bearer ${token}` }, timeout: 0 });
    return response.data;
};

// Удаление вводного файла заявки (менеджер)
export const APIManagerDeleteApplicationFile = async (id, fileId, token, options = {}) => {
    const url = API_URL + API_MANAGER_APPLICATIONS + `${id}/delete-file/${fileId}/`;
    const response = await axios.delete(url, { ...getAuthConfig(token),
        ...(options.draftOnly ? { params: { draft_only: 'true' } } : {}) });
    return response.data;
};

// План помещения (менеджер) — file=null очищает план
export const APIManagerUploadPlanFile = async (id, file, token, options = {}) => {
    const fd = new FormData();
    if (file) fd.append('file', file);
    else fd.append('clear', 'true');
    if (options.draftOnly) fd.append('draft_only', 'true');
    if (options.uploadId) fd.append('edit_upload_id', options.uploadId);
    const url = API_URL + API_MANAGER_APPLICATIONS + `${id}/plan-file/`;
    const response = await axios.post(url, fd, { headers: { Authorization: `Bearer ${token}` }, timeout: 0 });
    return response.data;
};




const API_DELETE_EVENT = '/main/api/delete-event'
// Запрос удаления события
export const APIDeleteEvent = async (token, id) => {
  try {
    const response = await axios.delete(API_URL + API_DELETE_EVENT + `/${id}/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};


const API_LOGIN = '/main/api/login/'
// Запрос авторизация
export const APILogin = async (email, password) => {
  try {
    const response = await axios.post(
      API_URL + API_LOGIN,
      { login: email, password: password },
      { timeout: 20000 },
    );
    return response.data;
  } catch (error) {
    // Возвращаем нормализованную ошибку: у формы входа всегда есть что показать
    return normalizeApiError(error, 'Не удалось войти. Проверьте данные.');
  }
};

const API_REGISTER_SURVEYOR = '/main/api/register-surveyor/'
// Регистрация обмерщика
export const APIRegisterSurveyor = async (data) => {
  try {
    const response = await axios.post(API_URL + API_REGISTER_SURVEYOR, data, { timeout: 20000 });
    return response.data;
  } catch (error) {
    return normalizeApiError(error, 'Не удалось отправить анкету. Проверьте поля.');
  }
};

export const APIRequestFirstPassword = async (login) => {
  try {
    const response = await axios.post(
      API_URL + '/main/api/request-first-password/',
      { login },
      { timeout: 20000 },
    );
    return response.data;
  } catch (error) {
    return normalizeApiError(error, 'Не удалось создать пароль. Обратитесь к менеджеру.');
  }
};

const API_AUTH_REQUEST_CALL = '/main/api/auth/request-call/';
export const APIRequestEmployeeCall = async (phone) => {
  try {
    const response = await axios.post(API_URL + API_AUTH_REQUEST_CALL, { phone });
    return response.data;
  } catch (error) {
    return normalizeApiError(error, 'Не удалось выполнить запрос');
  }
};

const API_AUTH_REQUEST_EMAIL_CODE = '/main/api/auth/request-email-code/';
export const APIRequestEmployeeEmailCode = async (email) => {
  try {
    const response = await axios.post(API_URL + API_AUTH_REQUEST_EMAIL_CODE, { email });
    return response.data;
  } catch (error) {
    return normalizeApiError(error, 'Не удалось выполнить запрос');
  }
};

const API_AUTH_VERIFY_CODE = '/main/api/auth/verify-code/';
// Принимаем объект { phone?, email?, code } — поддерживаем оба канала.
// Старый вызов вида APIVerifyEmployeeCode(phone, code) тоже работает.
export const APIVerifyEmployeeCode = async (contactOrPayload, code) => {
  try {
    let payload;
    if (typeof contactOrPayload === 'object' && contactOrPayload !== null) {
      // Новый вызов: APIVerifyEmployeeCode({ phone, code }) или { email, code }
      payload = contactOrPayload;
    } else {
      // Обратная совместимость: APIVerifyEmployeeCode(phone, code)
      payload = { phone: contactOrPayload, code };
    }
    const response = await axios.post(API_URL + API_AUTH_VERIFY_CODE, payload);
    return response.data;
  } catch (error) {
    return normalizeApiError(error, 'Не удалось выполнить запрос');
  }
};

const API_AUTH_RESET_PASSWORD = '/main/api/auth/reset-password/';
// Восстановление пароля по связке телефон + email
export const APIResetPassword = async ({ phone, email }) => {
  try {
    const response = await axios.post(API_URL + API_AUTH_RESET_PASSWORD, { phone, email });
    return response.data;
  } catch (error) {
    return normalizeApiError(error, 'Не удалось выполнить запрос');
  }
};





const API_GET_EMPLOYEE = '/main/api/get-employee/'
// Запрос получения информации сотрудника
export const APIGetEmployee = async (token) => {
  try {
    const response = await axios.get(API_URL + API_GET_EMPLOYEE, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.error('APIGetEmployee error:', error);
    const status = error?.response?.status;
    // Возвращаем объект с маркерами, чтобы вызывающий код мог отличить
    // настоящий "невалидный токен" от "временный сбой сети/сервера"
    return {
      _error: true,
      _status: status,
      _isAuthError: status === 401 || status === 403,
    };
  }
};



const API_UPDATE_DEALS = '/bitrix/api/update-birtrix-deal/'
// Запрос обновления сделок
export const APIUpdateDeals = async () => {
  try {
    const response = await axios.get(API_URL + API_UPDATE_DEALS, { params: { all: false }, timeout: 30000 });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};




const API_UPLOADS_FILE = '/main/api/upload/'
// Запрос отправки файлов на сервер
// Retain one identity per original File + deal across retries in this form.
const dealUploadRequests = new WeakMap();
function dealUploadId(file, dealId) {
    let ids = dealUploadRequests.get(file);
    if (!ids) { ids = new Map(); dealUploadRequests.set(file, ids); }
    const key = String(dealId);
    if (!ids.has(key)) {
        const bytes = crypto.getRandomValues(new Uint8Array(16));
        bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
        const hex = [...bytes].map(x => x.toString(16).padStart(2, '0')).join('');
        ids.set(key, `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`);
    }
    return ids.get(key);
}
export const APIUploadFiles = async (id, formData, {onProgress} = {}) => {
    if (!id) throw new Error('Не определена сделка для сохранения файлов. Повторите выбор заявки или сделки.');
    const files = formData.getAll('files');
    const uploaded = [];
    for (let index = 0; index < files.length; index++) {
        const file = files[index];
        const requestId = dealUploadId(file, id);
        for (let attempt = 0; ; attempt++) {
            const body = new FormData(); body.append('files', file); body.append('request_id', requestId);
            try {
                const response = await axios.post(`${API_URL}${API_UPLOADS_FILE}${id}/`, body, {
                    timeout: 600000,
                    onUploadProgress: event => onProgress?.({index, count: files.length, name: file.name,
                        percent: event.total ? Math.floor(event.loaded * 100 / event.total) : 0}),
                });
                if (response.data?.status !== 'ok') {
                    throw Object.assign(new Error(response.data?.detail || response.data?.message || 'Сервер не подтвердил сохранение файла'), {response});
                }
                uploaded.push(response.data); break;
            } catch (failure) {
                const normalized = normalizeApiError(failure, 'Не удалось сохранить файл');
                const retryable = !normalized.status || [408, 425, 429, 500, 502, 503, 504].includes(normalized.status);
                if (attempt < 2 && retryable) {
                    onProgress?.({index, count: files.length, name: file.name, retrying: true});
                    await new Promise(resolve => setTimeout(resolve, 1000 * 2 ** attempt));
                    continue;
                }
                const detail = normalized.status ? `${normalized.message} (HTTP ${normalized.status})` : normalized.message;
                throw Object.assign(new Error(`Файл «${file.name}»: ${detail}. Выбранные файлы сохранены в форме — повторите отправку.`),
                    {status: normalized.status, code: normalized.code, uploadedCount: uploaded.length});
            }
        }
    }
    return {status: 'ok', uploaded};
};



const API_GET_FILES = '/main/api/files/'
// Запрос получения файлов с диска
export const APIGetFiles = async (id) => {
  try {
    const response = await axios.get(API_URL + API_GET_FILES + `${id}/`);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

export const getBitrixFileProxyUrl = (fileId) => {
    return `${API_URL}/main/api/files/proxy/${fileId}/`;
};




const API_DELETE_FILE = '/main/api/delete-file/'
// Запрос удаления файла с диска
export const APIDeleteFile = async (fileId, fileName, dealId) => {
  try {
    const response = await axios.post(API_URL + API_DELETE_FILE, { 
      file_id: fileId, 
      file_name: fileName,
      deal_id: dealId 
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};



const API_DRAFTSMAN_SET_EVENT = '/main/api/draftsman-set-event/'
// Запрос прикрепления чертедника к событию
export const APIDraftsmanSetEvent = async (data, token) => {
  try {
    // Токен обязателен: сервер больше не доверяет полю draftsmen из тела
    // запроса и берёт личность из авторизации.
    const response = await axios.post(API_URL + API_DRAFTSMAN_SET_EVENT, data,
                                      getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};



const API_DRAFTSMAN_CHANGE_SAVE = '/main/api/draftsman-change-save/'
// Запрос сохранения данных от чертежника
export const APIDraftsmanChangeSave = async (eventId, data, token) => {
  try {
    // Токен обязателен: см. комментарий в APIDraftsmanSetEvent.
    const response = await axios.post(API_URL + API_DRAFTSMAN_CHANGE_SAVE + `${eventId}/`, data,
                                      { ...getAuthConfig(token), timeout: 60000 });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};


const API_PAYMENT_EMPLOYEES = '/data-statistic/payment-employees/'
// Запрос получения обмерщиков и чертежников в платежах
export const APIPaymentEmployees = async (token) => {
  try {
    const response = await axios.get(API_URL + API_PAYMENT_EMPLOYEES, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

export const APIPaymentAgreement = async (eventId, role, agreement, expectedAmount = null, token) => {
  try {
    const r = await axios.post(
      `${API_URL}/main/api/events/${eventId}/payment-agreement/`,
      { role, agreement, expected_amount: expectedAmount },
      getAuthConfig(token)
    );
    return r.data; // { status, role, agreement, expected_amount } | { error/message }
  } catch (e) {
    console.error('APIPaymentAgreement', e);
    return { error: e?.response?.data?.message || 'Не удалось сохранить ответ' };
  }
};

const API_GET_PAYMENT_EVENTS = '/data-statistic/payment-events/'
// Запрос списка платежей ЗП
export const APIGetPaymentEvent = async (page = 1, pageSize = 20, paymentStatus = 'all', surveyorId = null, draftsmanId = null, dateFrom = null, dateTo = null, token = null) => {
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('page_size', pageSize);
    
    if (paymentStatus !== 'all') params.append('payment_status', paymentStatus);
    if (surveyorId) params.append('surveyor_id', surveyorId);
    if (draftsmanId) params.append('draftsman_id', draftsmanId);
    if (dateFrom) params.append('date_from', dateFrom);
    if (dateTo) params.append('date_to', dateTo);

    const response = await axios.get(`${API_URL}${API_GET_PAYMENT_EVENTS}?${params.toString()}`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};


const API_DELETE_PAYMENT_EVENT = '/data-statistic/delete-payment-event/'
// Запрос удаления платежа
export const APIDeletePaymentEvent = async (id, deleteDuplicate = false, token = null) => {
  try {
    const response = await axios.delete(`${API_URL}${API_DELETE_PAYMENT_EVENT}${id}/`, {
      params: { delete_duplicate: deleteDuplicate },
      ...getAuthConfig(token)
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};


const API_EXPORT_TO_EXCEL = '/data-statistic/export-payments-to-excel/';

export const APIExportToExcel = async (data, token) => {
    try {
      const response = await axios.post(
        `${API_URL}${API_EXPORT_TO_EXCEL}`,
        data,
        {
            responseType: 'blob', // Важно для бинарных данных
            headers: {
                // 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
      );
      return response;
    } catch (error) {
        console.error('Export to Excel error:', error);
        throw error;
    }
};



const API_GET_ADDITIONAL_SERVICE = '/data-statistic/additional-services/'
// Запрос списка доп услуг
export const APIGetAdditionalService = async (token) => {
  try {
    const response = await axios.get(API_URL + API_GET_ADDITIONAL_SERVICE, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_GET_EVENT_ADDITIONAL_SERVICES = '/main/api/event-additional-services/'
// Запрос получения доп. услуг события
export const APIGetEventAdditionalServices = async (event_id, token) => {
  try {
    const response = await axios.get(API_URL + API_GET_EVENT_ADDITIONAL_SERVICES + `${event_id}/`, { ...getAuthConfig(token), timeout: 30000 });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_CREATE_EVENT_ADDITIONAL_SERVICE = '/main/api/event-additional-services/create/'
// Запрос создания доп. услуги для события
export const APICreateEventAdditionalService = async (data) => {
  try {
    const response = await axios.post(API_URL + API_CREATE_EVENT_ADDITIONAL_SERVICE, data);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_DELETE_EVENT_ADDITIONAL_SERVICE = '/main/api/event-additional-services/delete/'
// Запрос удаления доп. услуги из события
export const APIDeleteEventAdditionalService = async (id) => {
  try {
    const response = await axios.delete(API_URL + API_DELETE_EVENT_ADDITIONAL_SERVICE + `${id}/`);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_UPDATE_PAYMENT_EVENT = '/data-statistic/update-payment-event/'
// Запрос обновления данныз платежа
export const APIUpdatePaymentEvent = async (id, data, token) => {
  try {
    const response = await axios.patch(API_URL + API_UPDATE_PAYMENT_EVENT + `${id}/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};


const API_CREATE_ADDITIONAL_PAYMENT = '/data-statistic/create-additional-payment/'
// Запрос создание кастомной услуги
export const APICreateAdditionalPayment = async (data, token) => {
  try {
    const response = await axios.post(API_URL + API_CREATE_ADDITIONAL_PAYMENT, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};




const API_SUCCESS_FINISH_PAYMENT_EVENT = '/data-statistic/success-finish-payment-event/'
// Запрос подтверждения оплаты
export const APISuccessFinishPaymentEvent = async (id, data, token) => {
  try {
    const response = await axios.post(API_URL + API_SUCCESS_FINISH_PAYMENT_EVENT + `${id}/`, data, getAuthConfig(token));
    return response.data;
  } catch (error) {
    // 409 konsol_warning — не поломка, а осознанное предупреждение сервера:
    // задание в Консоли не готово, менеджер должен решить сам.
    const payload = error?.response?.data;
    if (error?.response?.status === 409 && payload?.status === 'konsol_warning') {
      return { ...payload, _konsolWarning: true };
    }
    console.error('APISuccessFinishPaymentEvent:', error?.message || error);
    return error;
  }
};

// Проверка готовности задания в Консоли ДО нажатия «Выплачено»
export const APIKonsolPayoutReadiness = async (paymentId, role, token) => {
  try {
    const r = await axios.get(
      `${API_URL}/data-statistic/finance/payments/${paymentId}/konsol-readiness/`,
      { ...getAuthConfig(token), params: { role } },
    );
    return r.data;
  } catch (e) {
    return { status: 'error', konsol: null };
  }
};



const API_GENERATE_DEAL_LINK = '/main/api/generate-deal-link/'
// Запрос генерации ссылки для подключения клиента
export const APIGenerateDealLink = async (deal_id, manager_id) => {
  try {
    const response = await axios.post(API_URL + API_GENERATE_DEAL_LINK, {
      deal_id: deal_id,
      manager_id: manager_id
    });
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};





const API_GET_STATISTICS = '/data-statistic/statistics/'
// Запрос генерации ссылки для подключения клиента
export const APIGetStatistics = async (params = {}, token) => {
    try {
        const response = await axios.get(API_URL + API_GET_STATISTICS, { ...getAuthConfig(token), params });
        return response.data;
    } catch (error) {
        console.error("Ошибка при получении статистики:", error);
        throw error;
    }
};



const API_GET_STATISTICS_EVENTS = '/data-statistic/statistics/events/'
// Запрос генерации ссылки для подключения клиента
export const APIGetStatisticsEvents = async (params = {}, token) => {
    try {
        const response = await axios.get(API_URL + API_GET_STATISTICS_EVENTS, {
            ...getAuthConfig(token),
            params: {
                ...params,
                page: params.page || 1,
                page_size: params.page_size || 10
            }
        });
        return response.data;
    } catch (error) {
        console.error("Ошибка при получении событий статистики:", error);
        throw error;
    }
};

export const APIGetStatisticsChartData = async (params, token) => {
    try {
        const query = Object.entries(params)
            .filter(([_, v]) => v !== null && v !== undefined && v !== '')
            .map(([k, v]) => `${k}=${v}`)
            .join('&');
        const response = await fetch(`${API_URL}/data-statistic/statistics/chart-data/?${query}`, {
            headers: { 'Authorization': `Bearer ${token}` },
        });
        return await response.json();
    } catch (e) {
        console.error('APIGetStatisticsChartData', e);
        return null;
    }
};



const API_UNSUCCESSFUL_CLOSE_EVENT = '/main/api/unsuccessful-close-event/'
// Запрос неудачного завершения события
export const APIUnsuccessfulCloseEvent = async (eventId, reason, token) => {
  try {
    const response = await axios.patch(`${API_URL}${API_UNSUCCESSFUL_CLOSE_EVENT}${eventId}/`, { reason }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    return { status: 'error', message: dispatchError(error?.response?.data || error) };
  }
};





// ===== Чаты Мессенджера =====


// Проверка токена
export const APIVerifyToken = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/chat/verify-token/`, getAuthConfig(token));
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error;
    }
};

// Создать чат с пациентом
export const APICreateChatWithPatient = async (patientId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/create-with-patient/`,
      { patient_id: patientId },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить чаты
// Список чатов. folder — id папки: сервер сам соберёт её состав по ручному
// списку и правилам автоподбора. null/undefined — все чаты.
export const APIGetChats = async (token, { limit = 20, offset = 0, folder = null } = {}) => {
  try {
    const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
    if (folder !== null && folder !== undefined) params.set('folder', String(folder));
    const response = await axios.get(
      `${API_URL}/chat/?${params.toString()}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// ── Папки чатов и закрепление ───────────────────────────────────────────
// Все возвращают тело ошибки, а не бросают: интерфейсу нужно показать
// причину текстом, а не молча ничего не сделать.

export const APIGetChatFolders = async (token) => {
  try {
    const res = await axios.get(`${API_URL}/chat/folders/`, getAuthConfig(token));
    return res.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось загрузить папки' };
  }
};

export const APICreateChatFolder = async (payload, token) => {
  try {
    const res = await axios.post(`${API_URL}/chat/folders/create/`, payload, getAuthConfig(token));
    return res.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось создать папку' };
  }
};

export const APIUpdateChatFolder = async (folderId, payload, token) => {
  try {
    const res = await axios.patch(`${API_URL}/chat/folders/${folderId}/`, payload, getAuthConfig(token));
    return res.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось сохранить папку' };
  }
};

export const APIDeleteChatFolder = async (folderId, token) => {
  try {
    const res = await axios.delete(`${API_URL}/chat/folders/${folderId}/`, getAuthConfig(token));
    return res.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось удалить папку' };
  }
};

export const APIReorderChatFolders = async (ids, token) => {
  try {
    const res = await axios.post(`${API_URL}/chat/folders/reorder/`, { ids }, getAuthConfig(token));
    return res.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось изменить порядок папок' };
  }
};

// action: 'add' | 'remove'
export const APIFolderToggleChat = async (folderId, chatId, action, token) => {
  try {
    const res = await axios.post(
      `${API_URL}/chat/folders/${folderId}/chats/`,
      { chat_id: chatId, action },
      getAuthConfig(token)
    );
    return res.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось изменить состав папки' };
  }
};

// Закрепление личное: у коллеги тот же чат останется на своём месте.
export const APIToggleChatPin = async (chatId, pinned, token) => {
  try {
    const res = await axios.post(
      `${API_URL}/chat/${chatId}/pin/`,
      { pinned },
      getAuthConfig(token)
    );
    return res.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось закрепить чат' };
  }
};

export const APILeaveChat = async (chatId, token) => {
  try {
    const res = await axios.post(`${API_URL}/chat/${chatId}/leave/`, {}, getAuthConfig(token));
    return res.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось покинуть чат' };
  }
};

// Удалить пользователя из чата
export const APIRemoveUserFromChat = async (chatId, employeeId, token) => {
  try {
    const response = await axios.delete(
      `${API_URL}/chat/${chatId}/remove-user/`,
      {
        ...getAuthConfig(token),
        data: { employee_id: employeeId }
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Получить участников чата
export const APIGetChatParticipants = async (chatId, token) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/${chatId}/participants/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// opts.anchor === 'unread' — открыть окно на границе непрочитанного
// (сервер сам подберёт, сколько отдать). opts.markRead === false — НЕ
// отмечать страницу прочитанной при загрузке: новый чат сообщает о
// прочтении сам, по факту показа сообщения на экране.
// Без opts поведение прежнее, чтобы старые вызовы не сломались.
export const APIGetChatMessagesSince = async (chatId, token, afterId) => {
  const response = await axios.get(`${API_URL}/chat/${chatId}/messages/since/`, {
    ...getAuthConfig(token), params: { after_id: afterId, limit: 100 },
  });
  return response.data;
};

export const APIGetChatMessagesById = async (chatId, token, limit = 30, offset = 0, opts = {}) => {
  try {
    const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
    if (opts.anchor) params.set('anchor', opts.anchor);
    if (opts.beforeId) { params.set('before_id', String(opts.beforeId)); params.set('offset', '0'); }
    if (opts.markRead === false) params.set('mark_read', '0');
    const response = await axios.get(
      `${API_URL}/chat/${chatId}/messages/?${params.toString()}`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Кто прочитал сообщение и кто поставил реакции.
export const APIGetMessageViews = async (chatId, messageId, token) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/${chatId}/messages/${messageId}/views/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось получить просмотры' };
  }
};

// Отметить весь чат прочитанным (кнопка «вниз» в ленте).
export const APIMarkChatReadAll = async (chatId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/${chatId}/read-all/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось отметить чат прочитанным' };
  }
};

// Гарантирует чат события и возвращает его id (создаёт, если чата нет).
export const APIEnsureEventChat = async (eventId, token) => {
    try {
        const r = await axios.post(
            `${API_URL}/chat/events/${eventId}/ensure/`,
            {},
            getAuthConfig(token),
        );
        return r.data; // { chat_id }
    } catch (e) {
        console.error('APIEnsureEventChat', e);
        return { error: e?.response?.data?.error || 'Не удалось открыть чат' };
    }
};

// Лента истории события (Задача 2). Сервер уже отфильтровал записи по роли.
export const APIEventHistory = async (eventId, token, limit = 50, offset = 0) => {
    try {
        const r = await axios.get(
            `${API_URL}/chat/events/${eventId}/history/?limit=${limit}&offset=${offset}`,
            getAuthConfig(token),
        );
        return r.data; // { history: [...], has_more: bool }
    } catch (e) {
        console.error('APIEventHistory', e);
        return { history: [], has_more: false, error: e?.response?.data?.error || 'Не удалось загрузить историю' };
    }
};

// Отправка сообщения в чат
export const APISendMessage = async (chatId, formData, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/${chatId}/send-message/`,
      formData,
      {
        timeout: 0,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// ── Действия над сообщением: удалить, изменить, реакция ─────────────────
// Пути совпадают с chats/urls.py (файл правок 13_БЭКЕНД_чат_действия.md).
// Все три возвращают тело ошибки, а не бросают: интерфейсу нужно показать
// причину (403 «только своё», 409 «срок правки истёк») текстом, а не молчанием.

export const APIDeleteMessage = async (chatId, messageId, token) => {
  try {
    const response = await axios.delete(
      `${API_URL}/chat/${chatId}/messages/${messageId}/delete/`,
      getAuthConfig(token),
    );
    return response.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось удалить сообщение' };
  }
};

export const APIEditMessage = async (chatId, messageId, content, token) => {
  try {
    const response = await axios.patch(
      `${API_URL}/chat/${chatId}/messages/${messageId}/edit/`,
      { content },
      getAuthConfig(token),
    );
    return response.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось изменить сообщение' };
  }
};

export const APIToggleMessageReaction = async (chatId, messageId, emoji, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/${chatId}/messages/${messageId}/reaction/`,
      { emoji },
      getAuthConfig(token),
    );
    return response.data;
  } catch (error) {
    return error?.response?.data || { error: 'Не удалось поставить реакцию' };
  }
};

// ── Голосовые сообщения ─────────────────────────────────────────────────
// Отправка голосового. blob — записанное аудио (webm/ogg/mp4),
// meta.duration — секунды (число), meta.waveform — массив пиков (0..100),
// meta.replyToId — если это ответ. onProgress(0..100) — индикатор загрузки,
// abortSignal — AbortController().signal, чтобы отменить отправку (Этап 3).
export const APISendVoiceMessage = async (
  chatId, blob, { duration, waveform, replyToId } = {}, token,
  onProgress = null, abortSignal = null,
) => {
  try {
    const fd = new FormData();
    const ext = (blob.type || '').includes('ogg') ? 'ogg'
              : (blob.type || '').includes('mp4') ? 'm4a' : 'webm';
    fd.append('attachments', blob, `voice.${ext}`);
    fd.append('type', 'voice');
    if (duration != null) fd.append('duration', String(duration));
    if (waveform) fd.append('waveform', JSON.stringify(waveform));
    if (replyToId) fd.append('reply_to_id', String(replyToId));

    const res = await axios.post(
      `${API_URL}/chat/${chatId}/send-message/`,
      fd,
      {
        headers: { 'Authorization': `Bearer ${token}` }, // boundary axios выставит сам
        timeout: 120000,
        ...(abortSignal ? { signal: abortSignal } : {}),
        onUploadProgress: (e) => {
          if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
        },
      }
    );
    return res.data; // созданное сообщение (с attachments[0].type === 'voice')
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Отметить голосовое прослушанным (гасит точку «не прослушано»).
export const APIMarkVoiceListened = async (chatId, messageId, token) => {
  try {
    const res = await axios.post(
      `${API_URL}/chat/${chatId}/voice/listened/`,
      { message_id: messageId },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return res.data; // { status:'ok', marked }
  } catch (error) {
    handleApiError(error);
    return null;
  }
};

// Фиксация прибытия обмерщика на объект (фото)
export const APISurveyorArrive = async (eventId, photoBlob, token, onProgress = null, uploadId = null) => {
  try {
    const fd = new FormData();
    fd.append('photo', photoBlob, 'arrival.jpg');
    if (uploadId) fd.append('upload_id', uploadId);

    const res = await axios.post(
      `${API_URL}/main/api/surveyor/events/${eventId}/arrive/`,
      fd,
      {
        headers: { 'Authorization': `Bearer ${token}` }, // FormData → axios сам выставит multipart с boundary
        timeout: 120000,                                  // мобильный интернет бывает медленным
        onUploadProgress: (e) => {
          if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
        },
      }
    );
    return res.data; // { status:'ok', arrived_at, photo_url }
  } catch (e) {
    const err = normalizeApiError(e, 'Не удалось отправить фото прибытия');
    // 413 от nginx приходит HTML-страницей — подставляем свой текст
    if (err.status === 413) {
      err.message = 'Фото слишком большое для отправки. Переснимите — оно сожмётся автоматически.';
    }
    return { status: 'error', detail: err.message, code: err.code, http_status: err.status };
  }
};

// WebSocket подключение к потоку сообщений
// Соединение чата.
//
// Что было не так. Единственным условием «не переподключаться» стояло
// e.wasClean — а сервер закрывает соединение ИМЕННО чисто: и по таймауту
// простоя за прокси, и при отказе в доступе. Стоило вкладке уйти в фон на
// полминуты, соединение закрывалось корректным close-фреймом, wasClean
// приходил true — и клиент больше не пробовал подключиться НИКОГДА.
// Статус при этом уже погас, поэтому в шапке навсегда повисало
// «соединение восстанавливается». Помогал только переход в другой чат:
// компонент пересоздавался и поднимал соединение заново.
//
// Что сделано:
//   • переподключаемся после любого закрытия, кроме нашего собственного
//     и осознанного отказа сервера (4001 — токен, 4003 — нет доступа);
//   • просыпаемся по возврату на вкладку, по возврату сети и по выходу
//     страницы из bfcache — не дожидаясь очередного шага backoff;
//   • сторож молчания считает по часам, а не по числу тиков: в фоновой
//     вкладке браузер режет таймеры до одного раза в минуту, и счётчик
//     пропущенных pong'ов врал бы;
//   • обработчики снимаются с брошенного сокета — иначе его запоздавший
//     onclose гасит статус уже открытого нового соединения.
//
// onFatal(code) — необязательный шестой аргумент: сервер отказал осознанно,
// переподключение не поможет, интерфейс должен сказать это прямо.
export const createWebSocketConnection = (chatId, token, onMessageCallback, onStatusChange, onReconnect, onFatal) => {
  let socket = null;
  let reconnectAttempts = 0;
  let hasConnectedBefore = false;
  let manualClose = false;
  let pingTimer = null;
  let retryTimer = null;
  let lastAliveAt = 0;
  const baseReconnectDelay = 1000;   // старт 1с
  const maxReconnectDelay = 30000;   // потолок 30с
  const silenceLimit = 70000;        // 70с без единого байта — считаем мёртвым

  // 4001 — токен не принят, 4003 — нет доступа к чату. Повторять бессмысленно.
  const FATAL_CODES = [4001, 4003];

  // Гасим безусловно. Проверка `if (timerId)` выглядит безобиднее, но id
  // таймера вполне может быть нулём — и тогда он не гасится никогда;
  // clearInterval(null) при этом совершенно безвреден.
  const clearTimers = () => {
    clearInterval(pingTimer); pingTimer = null;
    clearTimeout(retryTimer); retryTimer = null;
  };

  const detach = (s) => {
    if (!s) return;
    s.onopen = null; s.onmessage = null; s.onclose = null; s.onerror = null;
  };

  const startHeartbeat = () => {
    clearInterval(pingTimer);
    pingTimer = setInterval(() => {
      if (!socket || socket.readyState !== WebSocket.OPEN) return;
      const visible = typeof document === 'undefined'
        || document.visibilityState === 'visible';
      // Сторож включаем только на видимой вкладке: в фоне тишина нормальна,
      // там таймеры и так заморожены, а рвать живое соединение незачем.
      if (visible && lastAliveAt && (Date.now() - lastAliveAt > silenceLimit)) {
        try { socket.close(); } catch (_) {}   // дальше onclose → переподключение
        return;
      }
      try { socket.send(JSON.stringify({ type: 'ping' })); } catch (_) {}
    }, 25000);
  };

  const scheduleReconnect = () => {
    if (manualClose || retryTimer) return;
    const delay = Math.min(maxReconnectDelay, baseReconnectDelay * 2 ** reconnectAttempts);
    reconnectAttempts++;
    console.log(`WS: переподключение через ${Math.round(delay / 1000)}с (попытка ${reconnectAttempts})`);
    retryTimer = setTimeout(() => { retryTimer = null; connect(); }, delay);
  };

  const connect = () => {
    if (manualClose) return;
    if (socket && (socket.readyState === WebSocket.OPEN
                || socket.readyState === WebSocket.CONNECTING)) return;

    detach(socket);
    const ws = new WebSocket(`${WSS_URL}/chatws/${chatId}/?token=${token}`);
    socket = ws;

    ws.onopen = () => {
      if (socket !== ws) { try { ws.close(); } catch (_) {} return; }
      console.log('WebSocket соединение установлено');
      const wasReconnect = hasConnectedBefore;
      hasConnectedBefore = true;
      reconnectAttempts = 0;
      lastAliveAt = Date.now();
      onStatusChange?.(true);
      startHeartbeat();
      // На РЕконнекте — доподтягиваем сообщения, пришедшие за время обрыва
      if (wasReconnect) onReconnect?.();
    };

    ws.onmessage = (e) => {
      if (socket !== ws) return;
      lastAliveAt = Date.now();   // любой байт от сервера = соединение живо
      try {
        const data = JSON.parse(e.data);
        if (data?.type === 'pong') return;   // служебный ответ наверх не отдаём
        onMessageCallback(data);
      } catch (error) {
        console.error('Ошибка парсинга сообщения:', error);
      }
    };

    ws.onclose = (e) => {
      if (socket !== ws) return;   // закрылся брошенный сокет — не наше дело
      clearTimers();
      onStatusChange?.(false);
      if (manualClose) return;
      if (FATAL_CODES.indexOf(e.code) !== -1) {
        console.warn(`WS: сервер отказал (код ${e.code}) — переподключение не поможет`);
        onFatal?.(e.code);
        return;
      }
      scheduleReconnect();
    };

    // onerror всегда сопровождается onclose — статус снимаем там, чтобы не
    // мигать «отключено» на ещё устанавливающемся соединении.
    ws.onerror = (error) => { console.error('WebSocket ошибка:', error); };
  };

  connect();

  // Вернулись к вкладке / появилась сеть / страница достали из bfcache —
  // проверяем соединение сразу, не дожидаясь шага backoff.
  const wake = () => {
    if (manualClose) return;
    if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
    if (socket && socket.readyState === WebSocket.OPEN) {
      lastAliveAt = Date.now();   // пока нас не было, таймеры стояли
      return;
    }
    clearTimeout(retryTimer); retryTimer = null;
    reconnectAttempts = 0;
    connect();
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('online', wake);
    window.addEventListener('focus', wake);
    window.addEventListener('pageshow', wake);
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', wake);
    }
  }

  const close = () => {
    manualClose = true;
    clearTimers();
    if (typeof window !== 'undefined') {
      window.removeEventListener('online', wake);
      window.removeEventListener('focus', wake);
      window.removeEventListener('pageshow', wake);
      if (typeof document !== 'undefined') {
        document.removeEventListener('visibilitychange', wake);
      }
    }
    detach(socket);
    if (socket) { try { socket.close(1000, 'client'); } catch (_) {} socket = null; }
  };

  const isConnected = () => !!socket && socket.readyState === WebSocket.OPEN;

  return {
    close,
    isConnected,
  };
};


// Статус push-подписок сотрудника (для проактивного предложения подключить)
export const APIGetPushStatus = async (token, deviceToken = null) => {
  try {
    const response = await axios.get(`${API_URL}/chat/push/status/`, {
      headers: { Authorization: `Bearer ${token || getAuthToken()}` },
      params: deviceToken ? { device_token: deviceToken } : {},
      timeout: 15000,
    });
    return response.data; // { has_active, active_count, this_device, devices }
  } catch (error) {
    // Старый сервер без эндпоинта — не мешаем работе, просто не знаем статус
    return { has_active: null, active_count: 0, this_device: false, devices: [] };
  }
};

// Получить сотрудников без личных чатов
export const APIGetEmployeesWithoutDM = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/employees-without-dm/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Создать пустой чат (групповой)
export const APICreateEmptyChat = async (chatData, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/create-empty/`,
      chatData,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Добавить пользователя в чат
export const APIAddUserToChat = async (chatId, employeeId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/${chatId}/add-user/`,
      { employee_id: employeeId },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Создать чат с сотрудником
export const APICreateChatWithEmployee = async (employeeId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/create/`,
      { 
        partner_employee_id: employeeId,
        employee_id: JSON.parse(localStorage.getItem('userData'))?.id // или из контекста
      },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Создать групповой чат с выбранными участниками
export const APICreateGroupChat = async (name, memberIds, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/create-group/`,
      { name, member_ids: memberIds },
      getAuthConfig(token)
    );
    return response.data; // { chat_id, type_chat, name }
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Запрос сотрудников не в чате
export const APIGetEmployeesNotInChat = async (chatId, token) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/${chatId}/employees-not-in-chat/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};


// Получить количество непрочитанных сообщений
export const APIGetUnreadCounts = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/chat/unread-counts/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Отметить сообщения как прочитанные
export const APIMarkMessagesAsRead = async (chatId, messageIds, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/chat/${chatId}/mark-read/`,
      { message_ids: messageIds },
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// WebSocket подключение для уведомлений
// Соединение уведомлений.
//
// Здесь было две поломки, и обе видно по журналу сети.
//
// 1. Утечка таймеров. Внутри onopen стояло `const pingInterval = setInterval(...)`
//    — объявление ПЕРЕКРЫВАЛО внешнюю переменную с тем же именем. Внешняя так
//    и оставалась null, поэтому ни onclose, ни close() её не гасили. Каждое
//    переподключение добавляло ещё один таймер, и все они били ping'ом по
//    текущему сокету: в журнале видно по несколько ping/pong подряд с
//    разницей в миллисекунды.
//
// 2. Пять попыток — и тишина. После maxReconnectAttempts клиент переставал
//    подключаться до перезагрузки страницы: уведомления и счётчики
//    непрочитанного молча умирали на весь сеанс.
//
// Переподключаемся теперь бесконечно, с ограничением задержки, и просыпаемся
// при возврате на вкладку — как и соединение чата.
export const createNotificationWebSocketConnection = (token, onNotificationCallback, onStatusChange) => {
  let socket = null;
  let reconnectAttempts = 0;
  let manualClose = false;
  let pingTimer = null;
  let retryTimer = null;
  let lastAliveAt = 0;
  const baseReconnectDelay = 2000;
  const maxReconnectDelay = 30000;
  const silenceLimit = 70000;

  const FATAL_CODES = [4001];   // токен не принят

  // Гасим безусловно. Проверка `if (timerId)` выглядит безобиднее, но id
  // таймера вполне может быть нулём — и тогда он не гасится никогда;
  // clearInterval(null) при этом совершенно безвреден.
  const clearTimers = () => {
    clearInterval(pingTimer); pingTimer = null;
    clearTimeout(retryTimer); retryTimer = null;
  };

  const detach = (s) => {
    if (!s) return;
    s.onopen = null; s.onmessage = null; s.onclose = null; s.onerror = null;
  };

  const startHeartbeat = () => {
    clearInterval(pingTimer);
    pingTimer = setInterval(() => {
      if (!socket || socket.readyState !== WebSocket.OPEN) return;
      const visible = typeof document === 'undefined'
        || document.visibilityState === 'visible';
      if (visible && lastAliveAt && (Date.now() - lastAliveAt > silenceLimit)) {
        try { socket.close(); } catch (_) {}
        return;
      }
      try {
        socket.send(JSON.stringify({ type: 'ping', timestamp: Date.now() }));
      } catch (_) {}
    }, 25000);
  };

  const scheduleReconnect = () => {
    if (manualClose || retryTimer) return;
    const delay = Math.min(maxReconnectDelay, baseReconnectDelay * 2 ** reconnectAttempts);
    reconnectAttempts++;
    console.log(`Уведомления: переподключение через ${Math.round(delay / 1000)}с`);
    retryTimer = setTimeout(() => { retryTimer = null; connect(); }, delay);
  };

  const connect = () => {
    if (manualClose) return;
    if (socket && (socket.readyState === WebSocket.OPEN
                || socket.readyState === WebSocket.CONNECTING)) return;

    detach(socket);
    const ws = new WebSocket(`${WSS_URL}/notifications/?token=${token}`);
    socket = ws;

    ws.onopen = () => {
      if (socket !== ws) { try { ws.close(); } catch (_) {} return; }
      console.log('WebSocket уведомлений установлено');
      reconnectAttempts = 0;
      lastAliveAt = Date.now();
      onStatusChange?.(true);
      startHeartbeat();
    };

    ws.onmessage = (e) => {
      if (socket !== ws) return;
      lastAliveAt = Date.now();
      try {
        const data = JSON.parse(e.data);
        if (data?.type === 'pong') return;
        onNotificationCallback(data);
      } catch (error) {
        console.error('Ошибка парсинга уведомления:', error);
      }
    };

    ws.onclose = (e) => {
      if (socket !== ws) return;
      console.log(`WebSocket уведомлений закрыто: ${e.code} ${e.reason}`);
      clearTimers();
      onStatusChange?.(false);
      if (manualClose) return;
      if (FATAL_CODES.indexOf(e.code) !== -1) {
        console.warn(`Уведомления: сервер отказал (код ${e.code})`);
        return;
      }
      scheduleReconnect();
    };

    ws.onerror = (error) => { console.error('WebSocket уведомлений ошибка:', error); };
  };

  connect();

  const wake = () => {
    if (manualClose) return;
    if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
    if (socket && socket.readyState === WebSocket.OPEN) { lastAliveAt = Date.now(); return; }
    clearTimeout(retryTimer); retryTimer = null;
    reconnectAttempts = 0;
    connect();
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('online', wake);
    window.addEventListener('focus', wake);
    window.addEventListener('pageshow', wake);
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', wake);
    }
  }

  const close = () => {
    manualClose = true;
    clearTimers();
    if (typeof window !== 'undefined') {
      window.removeEventListener('online', wake);
      window.removeEventListener('focus', wake);
      window.removeEventListener('pageshow', wake);
      if (typeof document !== 'undefined') {
        document.removeEventListener('visibilitychange', wake);
      }
    }
    detach(socket);
    if (socket) { try { socket.close(1000, 'client'); } catch (_) {} socket = null; }
  };

  const isConnected = () => !!socket && socket.readyState === WebSocket.OPEN;

  return {
    close,
    isConnected
  };
};

// Тестовое PUSH уведомление
export const APITestPushNotification = async (token) => {
    const response = await axios.post(
        `${API_URL}/chat/push/test/`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
};

// Проверить подписку по device_token
export const APICheckPushByToken = async (token, deviceToken) => {
    const response = await axios.get(
        `${API_URL}/chat/push/check-token/`,
        {
            params: { device_token: deviceToken },
            headers: { Authorization: `Bearer ${token}` }
        }
    );
    return response.data;
};


// ── Центр уведомлений ──
export const APIGetNotifications = async (token, params = {}) => {
  try {
    const response = await axios.get(
      `${API_URL}/main/api/notifications/`,
      { ...getAuthConfig(token), params }
    );
    return response.data; // { results: [...], unread: N }
  } catch (error) {
    console.log('Ошибка загрузки уведомлений:', error);
    return { results: [], unread: 0 };
  }
};

export const APIMarkNotificationRead = async (id, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/main/api/notifications/${id}/read/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log('Ошибка отметки уведомления:', error);
    return { status: 'error' };
  }
};

export const APIMarkAllNotificationsRead = async (token) => {
  try {
    const response = await axios.post(
      `${API_URL}/main/api/notifications/read-all/`,
      {},
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.log('Ошибка отметки всех уведомлений:', error);
    return { status: 'error' };
  }
};

// Одно событие по id — для действия «Открыть событие» из уведомления
export const APIGetEventById = async (id, token) => {
  try {
    const response = await axios.get(
      `${API_URL}/main/api/events/${id}/detail/`,
      getAuthConfig(token)
    );
    return response.data; // сериализованное событие (совместимо с модалкой)
  } catch (error) {
    console.log('Ошибка загрузки события:', error);
    return null;
  }
};


// -=-=-=-=- Отзывы -=-=-=-=-

const API_CREATE_EMPLOYEE_REVIEW = '/data-statistic/api/employee-reviews/'

// Запрос создания отзыва о сотруднике
export const APICreateEmployeeReview = async (reviewData) => {
  try {
    const response = await axios.post(API_URL + API_CREATE_EMPLOYEE_REVIEW, reviewData);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_GET_EMPLOYEE_REVIEWS = '/data-statistic/api/employee-reviews/'

// Запрос получения отзывов о сотруднике
export const APIGetEmployeeReviews = async (employeeId) => {
  try {
    const response = await axios.get(API_URL + API_GET_EMPLOYEE_REVIEWS + `${employeeId}/`);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};

const API_GET_EMPLOYEE_REVIEWS_DETAILS = '/data-statistic/api/employee-reviews/'

// Запрос получения детальной информации об отзывах сотрудника
export const APIGetEmployeeReviewsDetails = async (employeeId) => {
  try {
    const response = await axios.get(API_URL + API_GET_EMPLOYEE_REVIEWS_DETAILS + `${employeeId}/details/`);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.code === 'ECONNABORTED') {
      console.error('Запрос превысил лимит ожидания.');
      return error;
    } 
    if (error.code === 'ERR_NETWORK') {
      console.error('Ошибка сети.');
      return error;
    } else {
      console.error('Произошла ошибка:', error.message);
      return error;
    }
  }
};


const API_SET_ADDITIONAL_MEASURING = '/main/api/events/';

// Установить статус "Дополнительный обмер"
export const SetAdditionalMeasuring = async (eventId, data, token) => {
    try {
        const response = await axios.post(
            API_URL + API_SET_ADDITIONAL_MEASURING + `${eventId}/set-additional-measuring/`,
            data,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('Ошибка установки доп. обмера:', error);
        return error;
    }
};

const API_CHANGE_EVENT_STATE = '/main/api/events/';

// Сменить стадию события (универсальный эндпоинт)
export const APIChangeEventState = async (eventId, data, token) => {
    try {
        const response = await axios.post(
            API_URL + API_CHANGE_EVENT_STATE + `${eventId}/change-state/`,
            data,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('Ошибка смены стадии события:', error);
        // Возвращаем тело ошибки чтобы фронт мог распарсить код questionnaire_required
        return error?.response?.data || { status: 'error', message: 'Ошибка смены стадии' };
    }
};

// ===== Тех. Поддержка =====

const API_TECH_SUPPORT_BASE = '/main/api/tech-support/';

// Создать обращение в техподдержку
export const APICreateTechSupportTicket = async (ticketData, token) => {
  try {
    const response = await axios.post(
      API_URL + API_TECH_SUPPORT_BASE + 'tickets/create/',
      ticketData,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    return { status: 'error', message: 'Ошибка при создании обращения' };
  }
};

// Получить список обращений
export const APIGetTechSupportTickets = async (params = {}, token) => {
  try {
    const response = await axios.get(
      API_URL + API_TECH_SUPPORT_BASE + 'tickets/',
      {
        params: params,
        ...getAuthConfig(token)
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    return { tickets: [], has_more: false };
  }
};

// Получить детали обращения
export const APIGetTechSupportTicketDetail = async (ticketId, token) => {
  try {
    const response = await axios.get(
      API_URL + API_TECH_SUPPORT_BASE + 'tickets/' + ticketId + '/',
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    return { status: 'error', message: 'Ошибка загрузки обращения' };
  }
};





// Эндпоинт для сохранения подписки (из вашего urls.py и views.py)
const API_REGISTER_PUSH = '/chat/push/subscribe/';

export const APIRegisterPushSubscription = async (subscriptionData, token) => {
  try {
    const response = await axios.post(
      API_URL + API_REGISTER_PUSH, 
      subscriptionData, 
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка регистрации PUSH:', error);
    throw error;
  }
};




// -=-=-=-=- Для обмерщиков -=-=-=-=-


export const APIGetSurveyorDashboard = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/main/api/surveyor/dashboard/`, getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.error('Ошибка регистрации PUSH:', error);
    throw error;
  }
};


export const APIUpdateMyProfile = async (data, token) => {
  try {
    const response = await axios.patch(`${API_URL}/main/api/surveyor/profile/update/`, JSON.stringify(data), getAuthConfig(token));
    return response.data;
  } catch (error) {
    console.error('Ошибка регистрации PUSH:', error);
    throw error;
  }
};

export const APIGetSurveyorCalendarEvents = async (token, start_date = null, end_date = null) => {
    try {
        const params = {};
        if (start_date) params.start_date = start_date;
        if (end_date)   params.end_date   = end_date;

        const response = await axios.get(
            `${API_URL}/main/api/surveyor/calendar/`,
            { ...getAuthConfig(token), params }
        );
        return response.data;
    } catch (error) {
        console.error('Ошибка загрузки событий обмерщика:', error.message);
        return [];
    }
};


// Получить статус процесса завершения по ID события
export const APIGetEventProcessStatus = async (eventId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}/main/api/surveyor/events/${eventId}/process-status/`,
            { timeout: 60000, headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (e) {
        return e?.response?.data || null;
    }
};

// Завершить событие (создать процесс выгрузки)
export const APICompleteEventSurveyor = async (eventId, comment, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/main/api/surveyor/events/${eventId}/complete/`,
      { comment },
      {
        timeout: 30000,
        headers: {
          'Authorization': `Bearer ${token}`
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка завершения события:', error);
    return { status: 'error', message: error?.response?.data?.message || 'Ошибка сети' };
  }
};

// Загрузить один файл в процесс завершения (с прогрессом)
export const APIUploadFileToProcess = (processId, file, fileType, token, onProgress) =>
    uploadSurveyorFile(API_URL, { processId, file, fileType, token, onProgress });

export const APIUploadFileToSupplement = (processId, file, fileType, token, onProgress) =>
    uploadSurveyorFile(API_URL, { processId, file, fileType, token, onProgress });

export const APIFinishUploading = async (processId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/main/api/surveyor/completion/${processId}/finish-upload/`,
      {},
      { timeout: 60000, headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    return { status: 'error', message: error?.response?.data?.message || 'Ошибка сети' };
  }
};

export const APIFinishSupplementUploading = async (processId, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/main/api/surveyor/supplement/${processId}/finish-upload/`,
      {},
      { timeout: 60000, headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    return { status: 'error', message: error?.response?.data?.message || 'Ошибка сети' };
  }
};

export const APIGetSurveyorEvents = async (token, params = {}) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await axios.get(
            `${API_URL}/main/api/surveyor/events/${query ? '?' + query : ''}`,
            { timeout: 45000, headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (e) {
        return null;
    }
};

// Проверить статус фоновой обработки
export const APIGetCompletionStatus = async (processId, token) => {
  try {
    const response = await axios.get(
      `${API_URL}/main/api/surveyor/completion/${processId}/status/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка получения статуса:', error);
    return { status: 'error' };
  }
};


// Для дозамера передаётся expected ID: позднее подтверждение не отменит новый цикл.
export const APIAcceptAdditional = async (eventId, expectedId, token) => {
  try {
    const response = await axios.post(`${API_URL}/main/api/surveyor/events/${eventId}/accept-additional/`,
      { expected_additional_id: expectedId }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    const data = error?.response?.data;
    return { ...data, status: 'error', message: data?.message || data?.detail || 'Не удалось принять дозамер' };
  }
};

export const APIStopAdditional = async (eventId, expectedId, reason, token) => {
  try {
    const response = await axios.post(`${API_URL}/main/api/events/${eventId}/remove-additional-measuring/`,
      { expected_additional_id: expectedId, additional_stop_reason: reason }, getAuthConfig(token));
    return response.data;
  } catch (error) {
    return { ...normalizeApiError(error, 'Не удалось снять дозамер'), status: 'error' };
  }
};

// Дополнить обмер (supplement)
export const APISupplementEventSurveyor = async (eventId, comment, token, additionalCycleId) => {
    try {
        const formData = new FormData();
        if (comment) formData.append('comment', comment);
        if (additionalCycleId !== undefined) {
            formData.append('additional_mode', '1');
            formData.append('expected_additional_id', additionalCycleId ?? 'null');
        }
        
        const response = await axios.post(
            `${API_URL}/main/api/surveyor/events/${eventId}/supplement/`,
            formData,
            { timeout: 15000, headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (error) {
        return { status: 'error', message: error?.response?.data?.message || 'Ошибка' };
    }
};

// Проверить статус процесса дополнения обмера
export const APIGetSupplementStatus = async (processId, token) => {
  try {
    const response = await axios.get(
      `${API_URL}/main/api/surveyor/supplement/${processId}/status/`,
      { ...getAuthConfig(token), timeout: 60000 }
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка получения статуса дополнения:', error);
    return { status: 'error' };
  }
};

// Получить активные процессы выгрузки при старте (для обмерщиков)
export const APIGetActiveProcesses = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/main/api/surveyor/processes/active/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('Ошибка получения активных процессов:', error);
        return { processes: [] };
    }
};

// Неудачное завершение события (обмерщик)
export const APIUnsuccessfulSurveyorCloseEvent = async (eventId, reasonType, comment, token, transferDate = null) => {
    try {
        const response = await axios.post(
            `${API_URL}/main/api/surveyor/events/${eventId}/unsuccessful/`,
            {
                reason_type: reasonType,
                comment: comment.trim(),
                // Дата переноса: только для причины «Перенесли». Пусто = неопределённая.
                transfer_date: reasonType === 'transferred' ? (transferDate || '') : '',
            },
            {
                headers: { 'Authorization': `Bearer ${token}` },
                timeout: 15000,
            }
        );
        return response.data;
    } catch (error) {
        return { status: 'error', message: error?.response?.data?.message || 'Ошибка соединения с сервером' };
    }
};



// Консоль.HRM — подключение и смена сценария приглашения.
function konsolOnboardingError(error) {
    const data = error?.response?.data;
    const detail = typeof data?.detail === 'string' ? data.detail
        : typeof data?.error === 'string' ? data.error
        : Array.isArray(data) ? data.join(' ') : null;
    return Object.assign(new Error(detail || 'Не удалось связаться с Консоль.HRM. Проверьте статус перед повторной отправкой.'),
        {status: error?.response?.status, data});
}
export const APIKonsolListScenarios = async () => {
    try {
        const response = await axios.get(API_URL + '/main/api/konsol/scenarios/');
        return response.data;
    } catch (error) { throw konsolOnboardingError(error); }
};

export const APIKonsolCreateInvite = async (employee_id, scenario_id) => {
    try {
        const response = await axios.post(API_URL + '/main/api/konsol/invite/create/', { employee_id, scenario_id }, {timeout: 60000});
        return response.data;
    } catch (error) { throw konsolOnboardingError(error); }
};

export const APIKonsolCheckInviteStatus = async (employee_id) => {
    try {
        const response = await axios.get(API_URL + `/main/api/konsol/invite/check/${employee_id}/`);
        return response.data;
    } catch (error) { throw konsolOnboardingError(error); }
};

// ═════════════════════════════════════════════════════════════════════════════
// Консоль Про × Платежи (задачи)
// ═════════════════════════════════════════════════════════════════════════════

const API_KONSOL_PAY = '/data-statistic/payments';

// GET — свежие статусы задач (обмерщик + чертежник) одним запросом
export const APIKonsolTaskSync = async (paymentId) => {
    try {
        const r = await axios.get(`${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/sync/`);
        return r.data;
    } catch (e) { console.error(e); return e; }
};

// POST — создать задачу для роли ('surveyor' | 'draftsman')
export const APIKonsolTaskCreate = async (paymentId, role, options = {}) => {
    try {
        const r = await axios.post(`${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/task/${role}/create/`, options);
        return r.data;
    } catch (e) { console.error(e); return e?.response?.data || { status: 'error', message: 'Ответ не получен; сначала сверить Консоль' }; }
};

// POST — принять задачу от лица компании
export const APIKonsolTaskConfirm = async (paymentId, role) => {
    try {
        const r = await axios.post(`${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/task/${role}/confirm/`);
        return r.data;
    } catch (e) { console.error(e); return e; }
};

// POST — отклонить задачу
export const APIKonsolTaskDecline = async (paymentId, role) => {
    try {
        const r = await axios.post(`${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/task/${role}/decline/`);
        return r.data;
    } catch (e) { console.error(e); return e; }
};

// POST — отозвать задачу (если ещё не принята исполнителем)
export const APIKonsolTaskRevoke = async (paymentId, role) => {
    try {
        const r = await axios.post(`${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/task/${role}/revoke/`);
        return r.data;
    } catch (e) { console.error(e); return e; }
};

// POST — завершить задачу (приёмка выполненной работы)
export const APIKonsolTaskAccept = async (paymentId, role) => {
    try {
        const r = await axios.post(`${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/task/${role}/accept/`);
        return r.data;
    } catch (e) { console.error(e); return e; }
};

// POST — пересоздать задачу (удалить старую → создать новую)
export const APIKonsolTaskRecreate = async (paymentId, role, options = {}) => {
    try {
        const r = await axios.post(`${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/task/${role}/recreate/`, options);
        return r.data;
    } catch (e) { console.error(e); return e?.response?.data || { status: 'error', message: 'Ответ не получен; сначала сверить Консоль' }; }
};

// POST — изменить период (дату) задания в Консоли (перенос / выравнивание для объединения)
export const APIKonsolTaskSetDates = async (paymentId, role, sinceDate, uptoDate = null) => {
    try {
        const r = await axios.post(
            `${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/task/${role}/dates/`,
            { since_date: sinceDate, upto_date: uptoDate || undefined }
        );
        return r.data;
    } catch (e) {
        return e?.response?.data || { status: 'error', message: 'Ошибка смены даты' };
    }
};

// DELETE — удалить задачу
export const APIKonsolTaskDelete = async (paymentId, role) => {
    try {
        const r = await axios.delete(`${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/task/${role}/`);
        return r.data;
    } catch (e) { console.error(e); return e; }
};

// POST — привязать существующее задание Консоли по номеру
export const APIKonsolTaskLink = async (paymentId, role, taskId, opts = {}) => {
    const { mode, force = false } = opts;
    try {
        const body = { task_id: taskId, force };
        if (mode) body.mode = mode;   // 'new' | 'replace'
        const r = await axios.post(
            `${API_URL}${API_KONSOL_PAY}/${paymentId}/konsol/task/${role}/link/`,
            body
        );
        return r.data;
    } catch (e) { console.error(e); return e?.response?.data || { status: 'error', message: 'Ошибка' }; }
};

// ── Состояние заданий Консоли по событию ──
// Показывает обе роли: есть ли задание, какая сумма ушла, почему не создано.
export const APIKonsolEventTasks = async (eventId, token) => {
  try {
    const r = await axios.get(
      `${API_URL}/data-statistic/konsol/events/${eventId}/tasks/`,
      getAuthConfig(token),
    );
    return r.data; // { event_id, tasks: { surveyor: {...}, draftsman: {...} } }
  } catch (e) {
    console.error('APIKonsolEventTasks', e);
    return { status: 'error', message: e?.response?.data?.message || 'Не удалось проверить Консоль' };
  }
};

// role: 'surveyor' | 'draftsman' | 'all'
// force_recreate=true — снять старое задание и создать новое
export const APIKonsolEventResync = async (eventId, data, token) => {
  try {
    const r = await axios.post(
      `${API_URL}/data-statistic/konsol/events/${eventId}/resync/`,
      data,
      getAuthConfig(token),
    );
    return r.data;
  } catch (e) {
    return { error: e?.response?.data?.error || e?.response?.data?.message || e?.response?.data?.detail || 'Не удалось пересинхронизировать' };
  }
};

export const APIKonsolEventCreateTask = async (eventId, role, amount, token, options = {}) => {
  try {
    const r = await axios.post(
      `${API_URL}/data-statistic/konsol/events/${eventId}/task/${role}/create/`,
      { amount, ...options },
      getAuthConfig(token)
    );
    return r.data; // { status, task } | { error }
  } catch (e) {
    console.error('APIKonsolEventCreateTask', e);
    return e?.response?.data || { status: 'error', message: 'Ответ не получен; сначала сверить Консоль' };
  }
};

// ── Объединение заданий Консоли в ОДИН акт ───────────────────────────────────
// Не путать с APIKonsolConsolidatePayments ниже: там несколько выплат
// склеиваются в ОДНО задание и связь «событие ↔ задание» теряется. Здесь
// задания остаются раздельными, объединяется только акт.

// Предпросмотр: ничего не меняет, говорит что войдёт в акт и что мешает.
export const APIKonsolActPreview = async (paymentIds, role) => {
    try {
        const r = await axios.post(
            `${API_URL}/data-statistic/konsol/acts/preview/`,
            { payment_ids: paymentIds, role }
        );
        return r.data; // { status, rows, eligible_count, total_amount, employee, can_combine, blocker }
    } catch (e) {
        console.error('APIKonsolActPreview', e);
        const data = e?.response?.data;
        return { ...(data && typeof data === 'object' ? data : {}), status: 'error',
            message: data?.message || (typeof data?.detail === 'string' ? data.detail : '') || e?.message || 'Ошибка запроса' };
    }
};

// date — обязательная дата выбранного акта в формате ГГГГ-ММ-ДД.
export const APIKonsolCombineActs = async (paymentIds, role, date) => {
    try {
        const r = await axios.post(
            `${API_URL}/data-statistic/konsol/acts/combine/`,
            { payment_ids: paymentIds, role, date: date || undefined, confirm_combined: true }
        );
        return r.data; // { status, group, split_by_konsol, payment_ids }
    } catch (e) {
        console.error('APIKonsolCombineActs', e);
        const data = e?.response?.data;
        return { ...(data && typeof data === 'object' ? data : {}), status: 'error',
            message: data?.message || (typeof data?.detail === 'string' ? data.detail : '') || e?.message || 'Ошибка запроса' };
    }
};

// Разъединение: задания снова показываются отдельно.
export const APIKonsolSplitActGroup = async (groupId) => {
    try {
        const r = await axios.post(
            `${API_URL}/data-statistic/konsol/acts/${groupId}/split/`, {}
        );
        return r.data; // { status, group, konsol_cancelled, message }
    } catch (e) {
        console.error('APIKonsolSplitActGroup', e);
        return e?.response?.data || { status: 'error', message: e?.message || 'Ошибка запроса' };
    }
};

// Журнал объединений.
export const APIKonsolActsList = async ({ active = 1, limit = 50 } = {}) => {
    try {
        const r = await axios.get(
            `${API_URL}/data-statistic/konsol/acts/`,
            { params: { active, limit } }
        );
        return r.data; // { status, groups: [...] }
    } catch (e) {
        console.error('APIKonsolActsList', e);
        return { status: 'error', groups: [] };
    }
};


// ── Контроль качества чертежей ───────────────────────────────────────────────
const API_QUALITY = '/main/api/quality';

// Список событий на контроле. scope: pending | rework | in_progress | done | all
export const APIQualityEvents = async (params = {}, token) => {
  try {
    const r = await axios.get(`${API_URL}${API_QUALITY}/events/`, {
      params, ...getAuthConfig(token),
    });
    return r.data; // { status, scope, count, has_more, events, counters }
  } catch (e) {
    console.error('APIQualityEvents', e);
    return e?.response?.data || { status: 'error', events: [], counters: {} };
  }
};

export const APIQualityFilterOptions = async (token) => {
  try {
    const r = await axios.get(`${API_URL}${API_QUALITY}/filter-options/`, getAuthConfig(token));
    return r.data; // { status, draftsmen, cities, counters }
  } catch (e) {
    console.error('APIQualityFilterOptions', e);
    return { status: 'error', draftsmen: [], cities: [] };
  }
};

export const APIQualityStats = async (days = 30, token) => {
  try {
    const r = await axios.get(`${API_URL}${API_QUALITY}/stats/`, {
      params: { days }, ...getAuthConfig(token),
    });
    return r.data;
  } catch (e) {
    console.error('APIQualityStats', e);
    return { status: 'error', by_draftsman: [] };
  }
};

export const APIQualityReviews = async (eventId, token) => {
  try {
    const r = await axios.get(`${API_URL}${API_QUALITY}/events/${eventId}/reviews/`,
                              getAuthConfig(token));
    return r.data; // { status, reviews: [...] }
  } catch (e) {
    console.error('APIQualityReviews', e);
    return { status: 'error', reviews: [] };
  }
};

// Принять чертёж: готово к выдаче; фактическая выдача — отдельное действие менеджера.
export const APIQualityApprove = async (eventId, { stars = 0, comment = '', qa_round } = {}, token) => {
  try {
    const r = await axios.post(`${API_URL}${API_QUALITY}/events/${eventId}/approve/`,
                                { stars, comment, qa_round }, getAuthConfig(token));
    return r.data;
  } catch (e) {
    console.error('APIQualityApprove', e);
    return e?.response?.data || { status: 'error', message: 'Не удалось принять работу' };
  }
};

// Вернуть на доработку. files — массив File, поэтому запрос multipart.
//
// getAuthConfig тут НЕ используется намеренно: он всегда ставит
// Content-Type: application/json, и для FormData это яд — axios видит
// заданный заголовок и не переписывает его, boundary в нём нет, а без
// boundary Django не разбирает ни файлы, ни текст. Запрос честно уходил и
// честно отлетал с «Не удалось отправить». Передаём только Authorization,
// как во всех остальных загрузках файлов в этом файле.
export const APIQualityRework = async (eventId, { comment, stars = 0, files = [], qa_round }, token) => {
  try {
    const fd = new FormData();
    fd.append('comment', comment || '');
    fd.append('qa_round', String(qa_round));
    fd.append('stars', String(stars || 0));
    (files || []).forEach((f) => fd.append('files', f));
    const r = await axios.post(`${API_URL}${API_QUALITY}/events/${eventId}/rework/`, fd, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return r.data;
  } catch (e) {
    console.error('APIQualityRework', e);
    const d = e?.response?.data;
    // DRF на отказ парсера отвечает detail, а не message — без этой ветки
    // настоящая причина терялась и человек видел глухое «Не удалось».
    if (d && typeof d === 'object') {
      return { status: 'error', ...d, message: d.message || d.detail || 'Не удалось отправить на доработку' };
    }
    return { status: 'error', message: 'Не удалось отправить на доработку' };
  }
};

// Чертёжник подтверждает, что взял доработку в работу.
export const APIQualityAcceptRework = async (eventId, token, qaRound) => {
  try {
    const r = await axios.post(`${API_URL}${API_QUALITY}/events/${eventId}/accept-rework/`,
                                qaRound == null ? {} : { qa_round: qaRound }, getAuthConfig(token));
    return r.data;
  } catch (e) {
    console.error('APIQualityAcceptRework', e);
    return e?.response?.data || { status: 'error', message: 'Не удалось принять доработку' };
  }
};


// ── Онлайн-статусы участников чата ───────────────────────────────────────────

// Кто в сети в конкретном чате + когда был последний раз.
export const APIChatPresence = async (chatId, token) => {
  try {
    const r = await axios.get(`${API_URL}/chat/${chatId}/presence/`, getAuthConfig(token));
    return r.data; // { status, participants, online_count, total_count, peer, is_group }
  } catch (e) {
    console.error('APIChatPresence', e);
    return { status: 'error', participants: [], online_count: 0 };
  }
};

// ── Закреплённые сообщения ───────────────────────────────────────────────────

// Закрепить или открепить сообщение. pinned не передаём — сервер переключит сам.
export const APIToggleMessagePin = async (chatId, messageId, pinned, token) => {
  try {
    const r = await axios.post(
      `${API_URL}/chat/${chatId}/messages/${messageId}/pin/`,
      pinned === undefined ? {} : { pinned: !!pinned },
      getAuthConfig(token),
    );
    return r.data; // { status, message_id, is_pinned, pinned }
  } catch (e) {
    console.error('APIToggleMessagePin', e);
    const d = e?.response?.data;
    if (d && typeof d === 'object') {
      return { status: 'error', ...d, message: d.message || d.detail || d.error
        || 'Не удалось изменить закрепление' };
    }
    return { status: 'error', message: 'Не удалось изменить закрепление' };
  }
};

// Все закреплённые чата, свежие сверху.
export const APIGetPinnedMessages = async (chatId, token) => {
  try {
    const r = await axios.get(`${API_URL}/chat/${chatId}/pinned/`, getAuthConfig(token));
    return r.data; // { status, chat_id, pinned: [{ id, content, author, pinned_at }] }
  } catch (e) {
    console.error('APIGetPinnedMessages', e);
    return { status: 'error', pinned: [] };
  }
};


// Сводка «сколько в сети» сразу по списку чатов — для левой колонки.
export const APIChatsPresenceBulk = async (chatIds, token) => {
  try {
    const r = await axios.post(`${API_URL}/chat/presence/bulk/`,
      { chat_ids: chatIds }, getAuthConfig(token));
    return r.data; // { status, chats: { "12": { online, total, peer_online } } }
  } catch (e) {
    console.error('APIChatsPresenceBulk', e);
    return { status: 'error', chats: {} };
  }
};


// Карточка события для раздела контроля: всё, по чему сверяют чертёж,
// одним запросом. Не зависит от общего списка событий.
export const APIQualityEventDetail = async (eventId, token) => {
  try {
    const r = await axios.get(`${API_URL}${API_QUALITY}/events/${eventId}/detail/`,
                              getAuthConfig(token));
    return r.data; // { status, event }
  } catch (e) {
    console.error('APIQualityEventDetail', e);
    return e?.response?.data || { status: 'error', message: 'Не удалось загрузить событие' };
  }
};


// Отзыв предложения сохраняет назначение исполнителя на сайте.
export const APIKonsolEventRevokeTask = async (eventId, role, token) => {
  try {
    const r = await axios.post(`${API_URL}/data-statistic/konsol/events/${eventId}/task/${role}/revoke/`, {}, getAuthConfig(token));
    return r.data;
  } catch (e) {
    return e?.response?.data || { status: 'error', message: 'Не удалось подтвердить отзыв предложения' };
  }
};

// Снять задание Консоли по событию — чтобы переназначить исполнителя.
// Сервер проверяет выплаты, акты и свежий статус; принятое в работу задание не снимается как предложение.
export const APIKonsolEventReleaseTask = async (eventId, role, token) => {
  try {
    const r = await axios.post(
      `${API_URL}/data-statistic/konsol/events/${eventId}/task/${role}/release/`,
      {},
      getAuthConfig(token)
    );
    return r.data; // { status, deleted_task_id, removed_in_konsol, message }
  } catch (e) {
    console.error('APIKonsolEventReleaseTask', e);
    return e?.response?.data || { status: 'error', message: e?.message || 'Ошибка запроса' };
  }
};


// body: { payment_ids: [int, ...], role: 'surveyor' | 'draftsman' }
export const APIKonsolConsolidatePayments = async (paymentIds, role) => {
    try {
        const r = await axios.post(
            `${API_URL}${API_KONSOL_PAY}/konsol/consolidate/`,
            { payment_ids: paymentIds, role }
        );
        return r.data;
    } catch (e) {
        console.error(e);
        return e?.response?.data || { status: 'error', message: e?.message || 'Ошибка запроса' };
    }
};





// Разделы базы знаний
export const APIGetKnowledgeSections = async (token) => {
    try {
        const response = await fetch(`${API_URL}/main/api/knowledge/sections/`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    } catch (e) { return []; }
};

export const APICreateKnowledgeSection = async (data, token) => {
    try {
        const response = await fetch(`${API_URL}/main/api/knowledge/sections/create/`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
        return await response.json();
    } catch (e) { return null; }
};

export const APIUpdateKnowledgeSection = async (id, data, token) => {
    try {
        const response = await fetch(`${API_URL}/main/api/knowledge/sections/${id}/`, {
            method: 'PATCH',
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
        return await response.json();
    } catch (e) { return null; }
};

export const APIDeleteKnowledgeSection = async (id, token) => {
    try {
        const response = await fetch(`${API_URL}/main/api/knowledge/sections/${id}/`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.ok;
    } catch (e) { return false; }
};


// База знаний
export const APIGetKnowledge = async (token, { category = null, sectionId = null } = {}) => {
    try {
        const params = new URLSearchParams();
        if (category) params.append('category', category);
        if (sectionId) params.append('section_id', sectionId);
        const url = `${API_URL}/main/api/knowledge/${params.toString() ? '?' + params : ''}`;
        const response = await fetch(url, { headers: { 'Authorization': `Bearer ${token}` } });
        return await response.json();
    } catch (e) { return []; }
};

export const APICreateKnowledgeArticle = async (data, token) => {
    try {
        const response = await fetch(`${API_URL}/main/api/knowledge/create/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) return null;
        return await response.json();
    } catch (e) {
        console.error('APICreateKnowledgeArticle', e);
        return null;
    }
};

export const APIUpdateKnowledgeArticle = async (id, data, token) => {
    try {
        const response = await fetch(`${API_URL}/main/api/knowledge/${id}/`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const result = await response.json();
        if (!response.ok) return { _error: true, ...result };
        return result;
    } catch (e) {
        console.error('APIUpdateKnowledgeArticle', e);
        return null;
    }
};

export const APIDeleteKnowledgeArticle = async (id, token) => {
    try {
        const response = await fetch(`${API_URL}/main/api/knowledge/${id}/`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` },
        });
        return response.status === 204;
    } catch (e) {
        console.error('APIDeleteKnowledgeArticle', e);
        return false;
    }
};





/**
 * Получить upload-ссылку для файла.
 * Django запросит href у Яндекс.Диска и вернёт proxy-URL.
 */
export const APIGetUploadUrl = async (dealId, fileName, fileType, processId, token, processType = 'complete') => {
    try {
        const response = await axios.post(
            `${API_URL}/main/api/surveyor/get-upload-url/`,
            {
                deal_id: dealId,
                file_name: fileName,
                file_type: fileType,
                process_id: processId,
                process_type: processType,
            },
            {
                timeout: 15000,
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Ошибка получения upload URL:', error);
        return { status: 'error', message: error?.response?.data?.message || 'Ошибка сети' };
    }
};

/**
 * Получить upload-ссылку для файла дополнения обмера.
 */
export const APIGetSupplementUploadUrl = async (dealId, fileName, fileType, processId, token) => {
    try {
        const response = await axios.post(
            `${API_URL}/main/api/surveyor/get-upload-url/`,
            {
                deal_id: dealId,
                file_name: fileName,
                file_type: fileType,
                process_id: processId,
                process_type: 'supplement',  // ← ключевое отличие
            },
            {
                timeout: 15000,
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Ошибка получения supplement upload URL:', error);
        return { status: 'error', message: error?.response?.data?.message || 'Ошибка сети' };
    }
};


/**
 * Загрузить файл через proxy на Битрикс.Диск.
 * POST multipart/form-data (вместо PUT binary на Яндекс).
 */
export const APIUploadFileDirect = (uploadUrl, file, onProgress, fieldName = 'file') => {
    return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        const fullUrl = `${API_URL}${uploadUrl}`;
        let formData = new FormData();
        formData.append(fieldName, file, file.name);

        xhr.open('POST', fullUrl, true);
        xhr.timeout = 0;

        const cleanup = () => {
            // Принудительно отвязываем колбэки и данные, чтобы помочь GC.
            // Без этого XHR + FormData + File могут жить в памяти долго.
            xhr.upload.onprogress = null;
            xhr.onload = null;
            xhr.onerror = null;
            xhr.ontimeout = null;
            xhr.onabort = null;
            formData = null;
        };

        xhr.upload.onprogress = (e) => {
            if (onProgress && e.lengthComputable && e.total > 0) {
                onProgress({
                    loaded: e.loaded,
                    total: e.total,
                    percent: Math.round((e.loaded * 100) / e.total),
                });
            }
        };

        xhr.onload = () => {
            const code = xhr.status;
            if (code >= 200 && code < 300) {
                let data = null;
                try { data = JSON.parse(xhr.responseText); } catch {}
                cleanup();
                resolve({ status: 'ok', code, data });
            } else {
                let msg = `HTTP ${code}`;
                try {
                    const j = JSON.parse(xhr.responseText);
                    msg = j?.error_description || j?.message || msg;
                } catch {}
                cleanup();
                resolve({ status: 'error', code, message: msg });
            }
        };

        xhr.onerror = () => {
            cleanup();
            resolve({ status: 'error', message: 'Ошибка сети' });
        };

        xhr.ontimeout = () => {
            cleanup();
            resolve({ status: 'error', message: 'Превышено время ожидания' });
        };

        try {
            xhr.send(formData);
        } catch (e) {
            cleanup();
            resolve({ status: 'error', message: e?.message || 'Не удалось отправить запрос' });
        }
    });
};

// Порог развилки между прокси-загрузкой и чанковой.
// Файлы меньше — проксей напрямую в Битрикс (старая схема).
// Файлы больше или равны — чанками на свой сервер, потом воркер.
export const CHUNK_THRESHOLD_BYTES = 30 * 1024 * 1024; // 30 МБ
export const CHUNK_SIZE_BYTES      = 5  * 1024 * 1024; // 5 МБ на чанк

export const APIChunkedInit = async (processId, file, fileType, token) => {
    try {
        const response = await axios.post(
            `${API_URL}/main/api/surveyor/chunked-upload/init/`,
            {
                process_id: processId,
                file_name:  file.name,
                file_type:  fileType,
                total_size: file.size,
                mime_type:  file.type || '',
            },
            {
                timeout: 15000,
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data; // { status: 'ok', upload_id: '...' }
    } catch (error) {
        return {
            status: 'error',
            message: error?.response?.data?.message || 'Ошибка инициализации загрузки',
        };
    }
};

export const APIChunkedStatus = async (uploadId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}/main/api/surveyor/chunked-upload/${uploadId}/status/`,
            {
                timeout: 10000,
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data; // { status: 'ok', received_bytes, total_size, state }
    } catch (error) {
        return {
            status: 'error',
            message: error?.response?.data?.message || 'Ошибка',
        };
    }
};

export const APIChunkedSendChunk = (uploadId, offset, chunkBlob, token, onProgress) => {
    return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        const url = `${API_URL}/main/api/surveyor/chunked-upload/${uploadId}/chunk/`;

        xhr.open('PUT', url, true);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        xhr.setRequestHeader('X-Upload-Offset', String(offset));
        xhr.timeout = 60000; // 60 сек на чанк — если не уложился, ретраим

        const cleanup = () => {
            xhr.upload.onprogress = null;
            xhr.onload = null;
            xhr.onerror = null;
            xhr.ontimeout = null;
            xhr.onabort = null;
        };

        xhr.upload.onprogress = (e) => {
            if (onProgress && e.lengthComputable) {
                onProgress({ loaded: e.loaded, total: e.total });
            }
        };

        xhr.onload = () => {
            const code = xhr.status;
            if (code >= 200 && code < 300) {
                let data = null;
                try { data = JSON.parse(xhr.responseText); } catch {}
                cleanup();
                resolve({ status: 'ok', code, data });
            } else if (code === 409) {
                // offset_mismatch — сервер скажет, какой у него
                let data = null;
                try { data = JSON.parse(xhr.responseText); } catch {}
                cleanup();
                resolve({ status: 'offset_mismatch', code, data });
            } else {
                let msg = `HTTP ${code}`;
                try {
                    const j = JSON.parse(xhr.responseText);
                    msg = j?.message || msg;
                } catch {}
                cleanup();
                resolve({ status: 'error', code, message: msg });
            }
        };

        xhr.onerror   = () => { cleanup(); resolve({ status: 'error', message: 'Ошибка сети' }); };
        xhr.ontimeout = () => { cleanup(); resolve({ status: 'error', message: 'Таймаут чанка' }); };

        try {
            xhr.send(chunkBlob);
        } catch (e) {
            cleanup();
            resolve({ status: 'error', message: e?.message || 'Не удалось отправить чанк' });
        }
    });
};

export const APIChunkedComplete = async (uploadId, token) => {
    try {
        const response = await axios.post(
            `${API_URL}/main/api/surveyor/chunked-upload/${uploadId}/complete/`,
            {},
            {
                timeout: 15000,
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data; // { status: 'ok' }
    } catch (error) {
        return {
            status: 'error',
            message: error?.response?.data?.message || 'Ошибка финализации',
        };
    }
};

/**
 * Загружает большой файл на свой сервер чанками с автоматическим resume.
 * При обрыве запрашивает у сервера, докуда тот дописал, и продолжает с этого места.
 *
 * onProgress({ loaded, total, percent }) — прогресс всего файла, не одного чанка.
 */
export const APIUploadFileChunked = options => uploadSurveyorFile(API_URL, options);


// ── Цели менеджеров ──────────────────────────────────────

export const APIGetManagerGoals = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.manager_id) query.set('manager_id', params.manager_id);
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        if (params.status) query.set('status', params.status);

        const response = await axios.get(
            `${API_URL}/main/api/manager-goals/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        if (params.throwOnError) throw error;
        console.error('APIGetManagerGoals:', error);
        return [];
    }
};

export const APICreateManagerGoal = async (data, token) => {
    const response = await axios.post(
        `${API_URL}/main/api/manager-goals/create/`,
        data,
        getAuthConfig(token)
    );
    return response.data;
};

export const APIUpdateManagerGoal = async (goalId, data, token) => {
    const response = await axios.patch(
        `${API_URL}/main/api/manager-goals/${goalId}/update/`,
        data,
        getAuthConfig(token)
    );
    return response.data;
};

export const APIDeleteManagerGoal = async (goalId, token) => {
    const response = await axios.delete(
        `${API_URL}/main/api/manager-goals/${goalId}/delete/`,
        getAuthConfig(token)
    );
    return response.data;
};

export const APIGetManagerKPI = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.manager_id) query.set('manager_id', params.manager_id);
        if (params.year_from) query.set('year_from', params.year_from);
        if (params.month_from) query.set('month_from', params.month_from);
        if (params.year_to) query.set('year_to', params.year_to);
        if (params.month_to) query.set('month_to', params.month_to);

        const response = await axios.get(
            `${API_URL}/main/api/manager-kpi/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetManagerKPI:', error);
        return null;
    }
};

export const APIGetManagerGoalsSummary = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);

        const response = await axios.get(
            `${API_URL}/main/api/manager-goals/summary/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetManagerGoalsSummary:', error);
        return null;
    }
};

// Краткая статистика по своему аккаунту (плашка на главной)
export const APIGetManagerDashboardBrief = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.manager_id) query.set('manager_id', params.manager_id);
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        const response = await axios.get(
            `${API_URL}/main/api/manager-dashboard-brief/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetManagerDashboardBrief:', error);
        return null;
    }
};

// Список менеджеров для модалки «Добавить менеджера»
export const APIGetManagersListForGoals = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        const response = await axios.get(
            `${API_URL}/main/api/manager-goals/managers-list/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetManagersListForGoals:', error);
        return [];
    }
};

// Рейтинг (кубки) за месяц — доступен любому менеджеру
export const APIGetManagerGoalsLeaderboard = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        const response = await axios.get(
            `${API_URL}/main/api/manager-goals/leaderboard/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetManagerGoalsLeaderboard:', error);
        return [];
    }
};

// ── Цели мастеров по качеству (Quality KPI) ──────────────

export const APIGetQualityGoals = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.quality_master_id) query.set('quality_master_id', params.quality_master_id);
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        if (params.status) query.set('status', params.status);

        const response = await axios.get(
            `${API_URL}/main/api/quality-goals/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        if (params.throwOnError) throw error;
        console.error('APIGetQualityGoals:', error);
        return [];
    }
};

export const APICreateQualityGoal = async (data, token) => {
    const response = await axios.post(
        `${API_URL}/main/api/quality-goals/create/`,
        data,
        getAuthConfig(token)
    );
    return response.data;
};

export const APIUpdateQualityGoal = async (goalId, data, token) => {
    const response = await axios.patch(
        `${API_URL}/main/api/quality-goals/${goalId}/update/`,
        data,
        getAuthConfig(token)
    );
    return response.data;
};

export const APIDeleteQualityGoal = async (goalId, token) => {
    const response = await axios.delete(
        `${API_URL}/main/api/quality-goals/${goalId}/delete/`,
        getAuthConfig(token)
    );
    return response.data;
};

export const APIGetQualityGoalsSummary = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        const response = await axios.get(
            `${API_URL}/main/api/quality-goals/summary/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetQualityGoalsSummary:', error);
        return null;
    }
};

export const APIGetQualityMastersListForGoals = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        const response = await axios.get(
            `${API_URL}/main/api/quality-goals/masters-list/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetQualityMastersListForGoals:', error);
        return [];
    }
};

export const APIGetQualityGoalsLeaderboard = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        const response = await axios.get(
            `${API_URL}/main/api/quality-goals/leaderboard/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetQualityGoalsLeaderboard:', error);
        return [];
    }
};

export const APIGetQualityDashboardBrief = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.quality_master_id) query.set('quality_master_id', params.quality_master_id);
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        const response = await axios.get(
            `${API_URL}/main/api/quality-dashboard-brief/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetQualityDashboardBrief:', error);
        return null;
    }
};

export const APIGetQualityTeamOverview = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.year) query.set('year', params.year);
        if (params.month) query.set('month', params.month);
        const response = await axios.get(
            `${API_URL}/main/api/quality-dashboard/team-overview/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetQualityTeamOverview:', error);
        return null;
    }
};


// ── Платежи клиентов (внутренний раздел, эквайринг) ──────

export const APIGetClientPaymentsStats = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.date_from) query.set('date_from', params.date_from);
        if (params.date_to) query.set('date_to', params.date_to);
        if (params.status) query.set('status', params.status);
        if (params.provider) query.set('provider', params.provider);
        if (params.city_id) query.set('city_id', params.city_id);
        if (params.include_archived) query.set('include_archived', params.include_archived);

        const response = await axios.get(
            `${API_URL}/main/api/client-payments/stats/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetClientPaymentsStats:', error);
        return null;
    }
};

export const APIGetClientPayments = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.search) query.set('search', params.search);
        if (params.status) query.set('status', params.status);
        if (params.provider) query.set('provider', params.provider);
        if (params.archived) query.set('archived', params.archived);
        if (params.date_from) query.set('date_from', params.date_from);
        if (params.date_to) query.set('date_to', params.date_to);
        if (params.page) query.set('page', params.page);
        if (params.page_size) query.set('page_size', params.page_size);

        const response = await axios.get(
            `${API_URL}/main/api/client-payments/?${query.toString()}`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetClientPayments:', error);
        return { results: [], total: 0, has_more: false };
    }
};

export const APIGetClientPaymentDetail = async (paymentId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}/main/api/client-payments/${paymentId}/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetClientPaymentDetail:', error);
        return null;
    }
};

export const APIArchiveClientPayment = async (paymentId, isArchived, token) => {
    const response = await axios.post(
        `${API_URL}/main/api/client-payments/${paymentId}/archive/`,
        { is_archived: isArchived },
        getAuthConfig(token)
    );
    return response.data;
};

export const APIRetryClientPayment = async (paymentId, token) => {
    const response = await axios.post(
        `${API_URL}/main/api/client-payments/${paymentId}/retry/`,
        {},
        getAuthConfig(token)
    );
    return response.data;
};

export const APISyncClientPayment = async (paymentId, token) => {
    const response = await axios.post(
        `${API_URL}/main/api/client-payments/${paymentId}/sync/`,
        {},
        getAuthConfig(token)
    );
    return response.data;
};

export const APIMarkPaidClientPayment = async (paymentId, token) => {
    const response = await axios.post(
        `${API_URL}/main/api/client-payments/${paymentId}/mark-paid/`,
        {},
        getAuthConfig(token)
    );
    return response.data;
};


// ── Клиенты (внутренний раздел «Клиенты», управление аккаунтами) ──

export const APIGetCabinetAccounts = async (token, search) => {
    const res = await axios.get(`${API_URL}/main/api/client/manager/cabinet-accounts/`, {
        ...getAuthConfig(token), params: { search }, timeout: 15000,
    });
    return res.data.results || [];
};

export const APIAttachApplicationCabinet = async (id, clientId, token) => {
    const res = await axios.post(`${API_URL}/main/api/client/manager/applications/${id}/attach-cabinet/`,
        { cabinet_client_id: clientId }, { ...getAuthConfig(token), timeout: 20000 });
    return res.data;
};

export const APIGetClients = async (token, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.search) query.set('search', params.search);
        if (params.client_type) query.set('client_type', params.client_type);
        if (params.client_category) query.set('client_category', params.client_category);
        if (params.is_blocked !== undefined && params.is_blocked !== '') query.set('is_blocked', params.is_blocked);
        if (params.only_parents !== undefined) query.set('only_parents', params.only_parents);
        if (params.page) query.set('page', params.page);
        if (params.page_size) query.set('page_size', params.page_size);

        const response = await axios.get(
            `${API_URL}/main/api/clients/?${query.toString()}`,
            { ...getAuthConfig(token), signal: params.signal }
        );
        return response.data;
    } catch (error) {
        if (params.throwOnError) throw error;
        console.error('APIGetClients:', error);
        return { results: [], total: 0, has_more: false };
    }
};

export const APIGetClientDetail = async (clientId, token, options = {}) => {
    try {
        const response = await axios.get(
            `${API_URL}/main/api/clients/${clientId}/`,
            { ...getAuthConfig(token), signal: options.signal }
        );
        return response.data;
    } catch (error) {
        if (options.throwOnError) throw error;
        console.error('APIGetClientDetail:', error);
        return null;
    }
};

export const APIUpdateClient = async (clientId, payload, token) => {
    // Кидаем исключение наверх, чтобы UI показал текст ошибки (например, дубль email/phone)
    const response = await axios.patch(
        `${API_URL}/main/api/clients/${clientId}/`,
        payload,
        getAuthConfig(token)
    );
    return response.data;
};

export const APIToggleBlockClient = async (clientId, isBlocked, token) => {
    const body = (isBlocked === undefined || isBlocked === null) ? {} : { is_blocked: isBlocked };
    const response = await axios.post(
        `${API_URL}/main/api/clients/${clientId}/toggle-block/`,
        body,
        getAuthConfig(token)
    );
    return response.data;
};

export const APIGetClientPermissions = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}/main/api/clients/permissions/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetClientPermissions:', error);
        return { permissions: [] };
    }
};

export const APIGetClientNotificationSettings = async (clientId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}/main/api/clients/${clientId}/notification-settings/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetClientNotificationSettings:', error);
        return null;
    }
};

export const APIUpdateClientNotificationSettings = async (clientId, payload, token) => {
    const response = await axios.patch(
        `${API_URL}/main/api/clients/${clientId}/notification-settings/`,
        payload,
        getAuthConfig(token)
    );
    return response.data;
};

export const APIUpdateClientChild = async (clientId, childId, payload, token) => {
    const response = await axios.patch(
        `${API_URL}/main/api/clients/${clientId}/children/${childId}/`,
        payload,
        getAuthConfig(token)
    );
    return response.data;
};

// Создать нового сотрудника ИЛИ привязать существующий аккаунт (attach_client_id) — этап 2 бэкенда
export const APICreateClientChild = async (clientId, payload, token) => {
    const response = await axios.post(
        `${API_URL}/main/api/clients/${clientId}/children/`,
        payload,
        getAuthConfig(token)
    );
    return response.data;
};

// Деактивировать сотрудника клиента
export const APIDeleteClientChild = async (clientId, childId, token) => {
    const response = await axios.post(
        `${API_URL}/main/api/clients/${clientId}/children/${childId}/delete/`,
        {},
        getAuthConfig(token)
    );
    return response.data;
};

export const APIGetClientApplications = async (clientId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}/main/api/clients/${clientId}/applications/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetClientApplications:', error);
        return { results: [], total: 0 };
    }
};

// Платежи конкретного клиента (для карточки). Имя иное, чтобы не путать с
// APIGetClientPayments — общим списком платежей на странице «Платежи клиентов».
export const APIGetClientAccountPayments = async (clientId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}/main/api/clients/${clientId}/payments/`,
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIGetClientAccountPayments:', error);
        return { results: [], total: 0, summary: {} };
    }
};

export const APICreateClient = async (payload, token) => {
    const response = await axios.post(
        `${API_URL}/main/api/clients/create/`,
        payload,
        getAuthConfig(token)
    );
    return response.data;
};


// ══════════════════════════════════════════════════════════════════════════════
//  EventDispatch — распределение событий между замерщиками
// ══════════════════════════════════════════════════════════════════════════════

const API_DISPATCH = '/main/api/dispatch';

export const APIDispatchStart = async (eventId, mode, slots = {}, token) => {
    // slots: { offered_dates: [...], offered_time_from, offered_time_to }
    try {
        const response = await axios.post(
            `${API_URL}${API_DISPATCH}/${eventId}/start/`,
            { mode, ...slots },
            getAuthConfig(token),
        );
        return response.data;
    } catch (e) { return { status: 'error', message: dispatchError(e?.response?.data) || e?.message, httpStatus: e?.response?.status }; }
};

export const APIDispatchRespond = async (dispatchId, data, token) => {
    // data: { broadcast_started_at, chosen_date, arrival_time, comment, employee_lat?, employee_lng? }
    try {
        const response = await axios.post(
            `${API_URL}${API_DISPATCH}/${dispatchId}/respond/`,
            data,
            getAuthConfig(token),
        );
        return response.data;
    } catch (e) { return { status: 'error', message: dispatchError(e?.response?.data) || e?.message, httpStatus: e?.response?.status }; }
};

export const APIDispatchAccept = async (dispatchId, responseId, token) => {
    try {
        const response = await axios.post(
            `${API_URL}${API_DISPATCH}/${dispatchId}/accept/${responseId}/`,
            {},
            getAuthConfig(token),
        );
        return response.data;
    } catch (e) { return { status: 'error', message: dispatchError(e?.response?.data) || e?.message, httpStatus: e?.response?.status }; }
};

export const APIDispatchConfirm = async (dispatchId, token, data = {}) => {
    try {
        const response = await axios.post(
            `${API_URL}${API_DISPATCH}/${dispatchId}/confirm/`,
            data,
            getAuthConfig(token),
        );
        return response.data;
    } catch (e) { return { status: 'error', message: dispatchError(e?.response?.data) || e?.message, httpStatus: e?.response?.status }; }
};

export const APIDispatchDecline = async (dispatchId, token, data = {}) => {
    try {
        const response = await axios.post(
            `${API_URL}${API_DISPATCH}/${dispatchId}/decline/`,
            data,
            getAuthConfig(token),
        );
        return response.data;
    } catch (e) { return { status: 'error', message: dispatchError(e?.response?.data) || e?.message, httpStatus: e?.response?.status }; }
};

export const APIDispatchDetail = async (dispatchId, token) => {
    try {
        const response = await axios.get(
            `${API_URL}${API_DISPATCH}/${dispatchId}/`,
            getAuthConfig(token),
        );
        return response.data;
    } catch (e) { return { status: 'error', message: dispatchError(e?.response?.data) || e?.message }; }
};

export const APIMyActiveDispatches = async (token) => {
    try {
        const response = await axios.get(
            `${API_URL}${API_DISPATCH}/my-active/`,
            getAuthConfig(token),
        );
        return response.data;
    } catch (e) { return { status: 'error', message: dispatchError(e?.response?.data) || e?.message }; }
};


// ══════════════════════════════════════════════════════════════════════════════
//  Зоны покрытия (EmployeeCoverageZone)
// ══════════════════════════════════════════════════════════════════════════════

const API_COVERAGE_ZONES = '/main/api/employee-coverage-zones';

// Получить зоны конкретного исполнителя
export const APIGetCoverageZones = async (employeeId, token) => {
    try {
        const r = await axios.get(
            `${API_URL}${API_COVERAGE_ZONES}/${employeeId}/`,
            getAuthConfig(token),
        );
        return r.data;
    } catch (e) {
        console.error('APIGetCoverageZones error:', e?.message);
        return [];
    }
};

// Создать зону (data: { employee, city_bitrix, region, district_name, radius_km, priority, is_active })
export const APICreateCoverageZone = async (data, token) => {
    try {
        const r = await axios.post(
            `${API_URL}${API_COVERAGE_ZONES}/create/`,
            data,
            getAuthConfig(token),
        );
        return r.data;
    } catch (e) {
        console.error('APICreateCoverageZone error:', e?.message);
        return { status: 'error', error: e?.message };
    }
};

// Обновить зону
export const APIUpdateCoverageZone = async (zoneId, data, token) => {
    try {
        const r = await axios.patch(
            `${API_URL}${API_COVERAGE_ZONES}/${zoneId}/update/`,
            data,
            getAuthConfig(token),
        );
        return r.data;
    } catch (e) {
        console.error('APIUpdateCoverageZone error:', e?.message);
        return { status: 'error', error: e?.message };
    }
};

// Удалить зону
export const APIDeleteCoverageZone = async (zoneId, token) => {
    try {
        const r = await axios.delete(
            `${API_URL}${API_COVERAGE_ZONES}/${zoneId}/delete/`,
            getAuthConfig(token),
        );
        return r.data;
    } catch (e) {
        console.error('APIDeleteCoverageZone error:', e?.message);
        return { status: 'error', error: e?.message };
    }
};



// ══════════════════════════════════════════════════════════════════════════════
//  Каталог: услуги / тарифы / доп.услуги / скидки  (data_statistic/catalog/*)
// ══════════════════════════════════════════════════════════════════════════════
const API_CATALOG = '/data-statistic/catalog';

// ── Услуги ──
export const APICatalogServicesList = async (token, params = {}) => {
  try {
    const q = new URLSearchParams();
    if (params.city_id) q.set('city_id', params.city_id);
    if (params.is_active !== undefined && params.is_active !== null) q.set('is_active', params.is_active);
    const r = await axios.get(`${API_URL}${API_CATALOG}/services/?${q.toString()}`, getAuthConfig(token));
    return r.data;
  } catch (e) { console.error('APICatalogServicesList', e); return []; }
};
export const APICatalogServiceGet = async (id, token) => {
  try {
    const r = await axios.get(`${API_URL}${API_CATALOG}/services/${id}/`, getAuthConfig(token));
    return r.data;
  } catch (e) { console.error('APICatalogServiceGet', e); return null; }
};
export const APICatalogServiceCreate = async (data, token) => {
  const r = await axios.post(`${API_URL}${API_CATALOG}/services/`, data, getAuthConfig(token));
  return r.data;
};
export const APICatalogServiceUpdate = async (id, data, token) => {
  const r = await axios.patch(`${API_URL}${API_CATALOG}/services/${id}/`, data, getAuthConfig(token));
  return r.data;
};
// archive=true → сервер скроет запись из выбора, но сохранит историю.
// Без archive сервер вернёт 409, если запись используется.
export const APICatalogServiceDelete = async (id, token, archive = false) => {
  try {
    const q = archive ? '?archive=1' : '';
    const r = await axios.delete(`${API_URL}${API_CATALOG}/services/${id}/${q}`, getAuthConfig(token));
    return r.data;
  } catch (e) {
    const d = e?.response?.data || {};
    return {
      error: d.message || 'Не удалось удалить услугу',
      in_use: e?.response?.status === 409,
      usage: d.usage || null,
    };
  }
};

// ── Тарифы ──
export const APICatalogTariffsList = async (token, params = {}) => {
  try {
    const q = new URLSearchParams();
    if (params.city_id) q.set('city_id', params.city_id);
    const r = await axios.get(`${API_URL}${API_CATALOG}/tariffs/?${q.toString()}`, getAuthConfig(token));
    return r.data;
  } catch (e) { console.error('APICatalogTariffsList', e); return []; }
};
export const APICatalogTariffCreate = async (data, token) => {
  const r = await axios.post(`${API_URL}${API_CATALOG}/tariffs/`, data, getAuthConfig(token));
  return r.data;
};
export const APICatalogTariffUpdate = async (id, data, token) => {
  const r = await axios.patch(`${API_URL}${API_CATALOG}/tariffs/${id}/`, data, getAuthConfig(token));
  return r.data;
};
export const APICatalogTariffDelete = async (id, token) => {
  const r = await axios.delete(`${API_URL}${API_CATALOG}/tariffs/${id}/`, getAuthConfig(token));
  return r.data;
};

// ── Базовое ТЗ на обмеры (подсказка/заготовка над полем ТЗ) ──
export const APICatalogBaseSpec = async (token) => {
  try {
    const r = await axios.get(`${API_URL}${API_CATALOG}/base-spec/`, getAuthConfig(token));
    return r.data; // { title, body, file_url }
  } catch (e) { console.error('APICatalogBaseSpec', e); return null; }
};

// ── Скидки тарифа ──
export const APICatalogDiscountCreate = async (data, token) => {
  const r = await axios.post(`${API_URL}${API_CATALOG}/discount-rules/`, data, getAuthConfig(token));
  return r.data;
};
export const APICatalogDiscountUpdate = async (id, data, token) => {
  const r = await axios.patch(`${API_URL}${API_CATALOG}/discount-rules/${id}/`, data, getAuthConfig(token));
  return r.data;
};
export const APICatalogDiscountDelete = async (id, token) => {
  const r = await axios.delete(`${API_URL}${API_CATALOG}/discount-rules/${id}/`, getAuthConfig(token));
  return r.data;
};

// ── Доп.услуги (полный CRUD для раздела управления) ──
export const APICatalogAddServicesList = async (token, params = {}) => {
  try {
    const q = new URLSearchParams();
    if (params.only_visible) q.set('only_visible', params.only_visible);
    const r = await axios.get(`${API_URL}${API_CATALOG}/additional-services/?${q.toString()}`, getAuthConfig(token));
    return r.data;
  } catch (e) { console.error('APICatalogAddServicesList', e); return []; }
};
export const APICatalogAddServiceCreate = async (data, token) => {
  const r = await axios.post(`${API_URL}${API_CATALOG}/additional-services/`, data, getAuthConfig(token));
  return r.data;
};
export const APICatalogAddServiceUpdate = async (id, data, token) => {
  const r = await axios.patch(`${API_URL}${API_CATALOG}/additional-services/${id}/`, data, getAuthConfig(token));
  return r.data;
};
export const APICatalogAddServiceDelete = async (id, token, archive = false) => {
  try {
    const q = archive ? '?archive=1' : '';
    const r = await axios.delete(`${API_URL}${API_CATALOG}/additional-services/${id}/${q}`, getAuthConfig(token));
    return r.data;
  } catch (e) {
    const d = e?.response?.data || {};
    return {
      error: d.message || 'Не удалось удалить доп. услугу',
      in_use: e?.response?.status === 409,
      usage: d.usage || null,
    };
  }
};

// ── Предпросмотр клиентской цены (модалка события) ──
export const APIClientPricePreview = async (data, token) => {
  // data: { service_id, square, city_id, additional_services: [...] }
  try {
    const r = await axios.post(`${API_URL}${API_CATALOG}/client-price-preview/`, data, getAuthConfig(token));
    return r.data; // { total, breakdown }
  } catch (e) { console.error('APIClientPricePreview', e); return null; }
};

// ── Расшифровка суммы выплаты ──
// Возвращает { payment_id, deal_id, address, square, square_source,
//              surveyor: { rows, total, is_paid }, draftsman: {...},
//              computed_at, is_snapshot, fresh?, diff? }
export const APIPaymentBreakdown = async (paymentId, token, recalc = false) => {
  try {
    const q = recalc ? '?recalc=1' : '';
    const r = await axios.get(
      `${API_URL}/data-statistic/payments/${paymentId}/breakdown/${q}`,
      getAuthConfig(token),
    );
    return r.data;
  } catch (e) {
    console.error('APIPaymentBreakdown', e);
    return { error: e?.response?.data?.message || 'Не удалось получить расшифровку' };
  }
};

// Пересчитать и СОХРАНИТЬ снимок. Для оплаченных ролей сервер вернёт 409.
export const APIPaymentBreakdownRefresh = async (paymentId, token) => {
  try {
    const r = await axios.post(
      `${API_URL}/data-statistic/payments/${paymentId}/breakdown/refresh/`,
      {},
      getAuthConfig(token),
    );
    return r.data;
  } catch (e) {
    const status = e?.response?.status;
    return {
      error: e?.response?.data?.message || 'Не удалось пересчитать',
      locked: status === 409,
    };
  }
};

// ── Выплаты текущего исполнителя (обмерщик / чертёжник) ──
// Показывает только свою роль. Чужие выплаты сервер отдаёт как 404.
export const APIMyPayments = async (token, { page = 1, pageSize = 50, dateFrom = null, dateTo = null } = {}) => {
  const q = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
  if (dateFrom) q.set('date_from', dateFrom);
  if (dateTo) q.set('date_to', dateTo);
  const r = await axios.get(`${API_URL}/main/api/my-payments/?${q.toString()}`, getAuthConfig(token));
  return r.data; // { results, totals, grade, has_more, page, ... }
};

// Расшифровка своей выплаты. Возвращает { rows, total, role, ... }
export const APIMyPaymentBreakdown = async (paymentId, token) => {
  try {
    const r = await axios.get(
      `${API_URL}/main/api/my-payments/${paymentId}/breakdown/`,
      getAuthConfig(token),
    );
    return r.data;
  } catch (e) {
    console.error('APIMyPaymentBreakdown', e);
    return { error: e?.response?.data?.message || 'Не удалось получить расшифровку' };
  }
};

// Расшифровка выплаты по событию (по своей роли). { rows, total, square, role, ... }
export const APIEventPaymentBreakdown = async (eventId, token) => {
  try {
    const r = await axios.get(
      `${API_URL}/main/api/events/${eventId}/payment-breakdown/`,
      getAuthConfig(token),
    );
    return r.data;
  } catch (e) {
    console.error('APIEventPaymentBreakdown', e);
    return { error: e?.response?.data?.message || 'Не удалось получить расшифровку' };
  }
};

// ── Выезд (трансфер) ──
// Предпросмотр: считает сумму по километражу и ставке города, ничего не сохраняет.
export const APITransferPreview = async (data, token) => {
  // data: { km, city_id } либо { km, deal_id }
  try {
    const r = await axios.post(
      `${API_URL}/main/api/events/transfer-preview/`,
      data,
      getAuthConfig(token),
    );
    return r.data; // { km, rate, rate_source, amount }
  } catch (e) {
    console.error('APITransferPreview', e);
    return null;
  }
};

// Правка выезда у существующего события.
// body — один из: { km }, { amount }, { reset: true }
// Для события с проведённой выплатой обмерщику сервер вернёт 409.
export const APIEventSetTransfer = async (eventId, data, token) => {
  try {
    const r = await axios.patch(
      `${API_URL}/main/api/events/${eventId}/transfer/`,
      data,
      getAuthConfig(token),
    );
    return r.data;
  } catch (e) {
    return {
      error: e?.response?.data?.message || 'Не удалось изменить выезд',
      locked: e?.response?.status === 409,
    };
  }
};

// ── Скидки (каталог, новые) — /catalog/discounts/ ──
export const APICatalogDiscountsList = async (token, params = {}) => {
  try {
    const q = new URLSearchParams();
    if (params.is_active !== undefined && params.is_active !== null) q.set('is_active', params.is_active);
    if (params.reason) q.set('reason', params.reason);
    const r = await axios.get(`${API_URL}${API_CATALOG}/discounts/?${q.toString()}`, getAuthConfig(token));
    return r.data;
  } catch (e) { console.error('APICatalogDiscountsList', e); return []; }
};
export const APICatalogDiscountItemCreate = async (data, token) => {
  const r = await axios.post(`${API_URL}${API_CATALOG}/discounts/`, data, getAuthConfig(token));
  return r.data;
};
export const APICatalogDiscountItemUpdate = async (id, data, token) => {
  const r = await axios.patch(`${API_URL}${API_CATALOG}/discounts/${id}/`, data, getAuthConfig(token));
  return r.data;
};
export const APICatalogDiscountItemDelete = async (id, token, archive = false) => {
  try {
    const q = archive ? '?archive=1' : '';
    const r = await axios.delete(`${API_URL}${API_CATALOG}/discounts/${id}/${q}`, getAuthConfig(token));
    return r.data;
  } catch (e) {
    const d = e?.response?.data || {};
    return {
      error: d.message || 'Не удалось удалить скидку',
      in_use: e?.response?.status === 409,
      usage: d.usage || null,
    };
  }
};

// ── Скидки события (применённые) ──
export const APIGetEventDiscounts = async (eventId, token) => {
  try {
    const r = await axios.get(`${API_URL}/main/api/events/${eventId}/discounts/`, getAuthConfig(token));
    return r.data;
  } catch (e) { console.error('APIGetEventDiscounts', e); return []; }
};
export const APICreateEventDiscount = async (eventId, data, token) => {
  const r = await axios.post(`${API_URL}/main/api/events/${eventId}/discounts/`, data, getAuthConfig(token));
  return r.data;
};
export const APICalcSalaries = async (data, token) => {
    // data: { city, square } → { surveyor_salary, draftsman_salary, surveyor_missing[], draftsman_missing[] }
    try {
        const response = await axios.post(API_URL + '/main/api/events/calc-salaries/', data, getAuthConfig(token));
        return response.data;
    } catch (e) {
        return null;
    }
};
export const APIUpdateEventDiscount = async (id, data, token) => {
  const r = await axios.patch(`${API_URL}/main/api/event-discounts/${id}/`, data, getAuthConfig(token));
  return r.data;
};
export const APIDeleteEventDiscount = async (id, token) => {
  const r = await axios.delete(`${API_URL}/main/api/event-discounts/${id}/`, getAuthConfig(token));
  return r.data;
};

// ══════════════════════════════════════════════════════════════════════════════
//  Итоговая стоимость события + платежи Точки «от события»  (main/api/*)
// ══════════════════════════════════════════════════════════════════════════════

export const APISetEventFinalPrice = async (eventId, data, token) => {
  // data: { final_price, is_manual, sync_bitrix } или { is_manual: false }
  const r = await axios.patch(`${API_URL}/main/api/events/${eventId}/final-price/`, data, getAuthConfig(token));
  return r.data;
};

export const APIGetEventPayment = async (eventId, token) => {
  try {
    const r = await axios.get(`${API_URL}/main/api/events/${eventId}/payment/`, getAuthConfig(token));
    return r.data; // { active, history }
  } catch (e) { console.error('APIGetEventPayment', e); return { active: null, history: [] }; }
};

export const APICreateEventPayment = async (eventId, data, token) => {
  // data: { force_new, amount }
  try {
    const r = await axios.post(`${API_URL}/main/api/events/${eventId}/payment/create/`, data, getAuthConfig(token));
    return r.data;
  } catch (e) { return e?.response?.data || { status: 'error', detail: e?.message }; }
};

export const APIDeleteClientPayment = async (paymentId, token) => {
  const r = await axios.delete(`${API_URL}/main/api/client-payments/${paymentId}/delete/`, getAuthConfig(token));
  return r.data;
};


// ═══════════════════════════════════════════════════════════════════
//  ФИНАНСЫ (дашборд руководителя) — /data-statistic/finance/*
// ═══════════════════════════════════════════════════════════════════
const FIN = API_URL + '/data-statistic/finance';

// P&L
export const APIFinancePnl = (params, token) =>
  axios.get(`${FIN}/pnl/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinancePnlDeals = (params, token) =>
  axios.get(`${FIN}/pnl/deals/`, { ...getAuthConfig(token), params }).then(r => r.data);

// Показатели здоровья + ручной ввод баланса
export const APIFinanceHealth = (params, token) =>
  axios.get(`${FIN}/health/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinanceManualInputs = (token) =>
  axios.get(`${FIN}/manual-inputs/`, getAuthConfig(token)).then(r => r.data);
export const APIFinanceManualInputSave = (data, token) =>
  axios.post(`${FIN}/manual-inputs/`, data, getAuthConfig(token)).then(r => r.data);

// ДДС / операции
export const APIFinanceOperations = (params, token) =>
  axios.get(`${FIN}/operations/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinanceOperationCreate = (data, token) =>
  axios.post(`${FIN}/operations/`, data, getAuthConfig(token)).then(r => r.data);
export const APIFinanceOperationUpdate = (id, data, token) =>
  axios.patch(`${FIN}/operations/${id}/`, data, getAuthConfig(token)).then(r => r.data);
export const APIFinanceOperationDelete = (id, token) =>
  axios.delete(`${FIN}/operations/${id}/`, getAuthConfig(token)).then(r => r.data);
export const APIFinanceOperationReconcile = (id, data, token) =>
  axios.post(`${FIN}/operations/${id}/reconcile/`, data, getAuthConfig(token)).then(r => r.data);
export const APIFinanceCashflow = (params, token) =>
  axios.get(`${FIN}/cashflow/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinanceCategories = (params, token) =>
  axios.get(`${FIN}/categories/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinanceCategoryCreate = (data, token) =>
  axios.post(`${FIN}/categories/`, data, getAuthConfig(token)).then(r => r.data);
export const APIFinanceAccounts = (params, token) =>
  axios.get(`${FIN}/accounts/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinanceAccountCreate = (data, token) =>
  axios.post(`${FIN}/accounts/`, data, getAuthConfig(token)).then(r => r.data);

// Дебиторка
export const APIFinanceReceivables = (params, token) =>
  axios.get(`${FIN}/receivables/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinanceReceivablesDetails = (params, token) =>
  axios.get(`${FIN}/receivables/details/`, { ...getAuthConfig(token), params }).then(r => r.data);

// Кредиторка
export const APIFinancePayables = (params, token) =>
  axios.get(`${FIN}/payables/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinancePayablesDetails = (params, token) =>
  axios.get(`${FIN}/payables/details/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinancePayablesSyncAll = (token) =>
  axios.post(`${FIN}/payables/konsol/sync-all/`, {}, getAuthConfig(token)).then(r => r.data);

// Платёжный календарь + регулярные обязательства
export const APIFinancePaymentCalendar = (params, token) =>
  axios.get(`${FIN}/payment-calendar/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinanceRecurring = (params, token) =>
  axios.get(`${FIN}/recurring/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinanceRecurringCreate = (data, token) =>
  axios.post(`${FIN}/recurring/`, data, getAuthConfig(token)).then(r => r.data);
export const APIFinanceRecurringUpdate = (id, data, token) =>
  axios.patch(`${FIN}/recurring/${id}/`, data, getAuthConfig(token)).then(r => r.data);
export const APIFinanceRecurringDelete = (id, token) =>
  axios.delete(`${FIN}/recurring/${id}/`, getAuthConfig(token)).then(r => r.data);

// Замеры + вознаграждения
export const APIFinanceSurveysBreakdown = (params, token) =>
  axios.get(`${FIN}/surveys-breakdown/`, { ...getAuthConfig(token), params }).then(r => r.data);
export const APIFinanceRewards = (params, token) =>
  axios.get(`${FIN}/rewards/`, { ...getAuthConfig(token), params }).then(r => r.data);



// ===================== КАНБАН =====================
const API_KANBAN_EVENTS         = '/main/api/kanban/events/';
const API_KANBAN_SUMMARY        = '/main/api/kanban/summary/';
const API_KANBAN_APPLICATIONS   = '/main/api/client/manager/kanban/applications/';
const API_KANBAN_FILTER_OPTIONS = '/main/api/kanban/filter-options/';
const API_KANBAN_FILTERS        = '/main/api/kanban/filters/';

// Список событий одной колонки (пагинация по 10)
export const APIGetKanbanEvents = async ({ stage, page = 1, page_size = 10, search = '', order = 'desc', filters = {} }, token) => {
    try {
        const params = { stage, page, page_size, order };
        if (search) params.search = search;
        // Добавляем непустые параметры фильтра (manager, city, amount_op, date_*, deadline, …)
        Object.entries(filters || {}).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== '') params[k] = v;
        });
        const res = await axios.get(API_URL + API_KANBAN_EVENTS, { params, ...getAuthConfig(token) });
        return res.data; // { stage, results, page, pages, count, has_next }
    } catch (e) {
        console.error('APIGetKanbanEvents:', e);
        return { stage, results: [], page: 1, pages: 1, count: 0, has_next: false };
    }
};

// Колонка «Заявки» (пагинация по 10)
export const APIGetKanbanApplications = async ({ page = 1, page_size = 10, search = '', order = 'desc', filters = {} }, token) => {
    try {
        const params = { page, page_size, order };
        if (search) params.search = search;
        Object.entries(filters || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') params[key] = value;
        });
        const res = await axios.get(API_URL + API_KANBAN_APPLICATIONS, { params, ...getAuthConfig(token) });
        return res.data; // { results, page, pages, count, has_next }
    } catch (e) {
        console.error('APIGetKanbanApplications:', e);
        return { results: [], page: 1, pages: 1, count: 0, has_next: false };
    }
};

// Счётчики по всем колонкам (не обязателен — count приходит и в списках)
export const APIGetKanbanSummary = async (token, filters = {}) => {
    try {
        const params = {};
        Object.entries(filters || {}).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== '') params[k] = v;
        });
        const res = await axios.get(API_URL + API_KANBAN_SUMMARY, { params, ...getAuthConfig(token) });
        // { counts, month, success_month, unsuccess_month, success_diff_percent, completed_month }
        return res.data || {};
    } catch (e) {
        console.error('APIGetKanbanSummary:', e);
        return {};
    }
};

// Справочники для панели фильтра канбана (сотрудники, города, регионы, условия суммы)
export const APIGetKanbanFilterOptions = async (token) => {
    try {
        const res = await axios.get(API_URL + API_KANBAN_FILTER_OPTIONS, getAuthConfig(token));
        return res.data || {};
    } catch (e) {
        console.error('APIGetKanbanFilterOptions:', e);
        return { stages: [], employees: [], cities: [], regions: [], amount_ops: [], amount_fields: [] };
    }
};

// ── Сохранённые фильтры канбана (пресеты) ──
export const APIGetKanbanFilters = async (token) => {
    try {
        const res = await axios.get(API_URL + API_KANBAN_FILTERS, getAuthConfig(token));
        return res.data?.results || [];
    } catch (e) {
        console.error('APIGetKanbanFilters:', e);
        return [];
    }
};

export const APICreateKanbanFilter = async ({ name, params = {}, is_shared = false, is_default = false }, token) => {
    try {
        const res = await axios.post(
            API_URL + API_KANBAN_FILTERS + 'create/',
            { name, params, is_shared, is_default },
            getAuthConfig(token),
        );
        return res.data;
    } catch (e) {
        console.error('APICreateKanbanFilter:', e);
        return null;
    }
};

export const APIUpdateKanbanFilter = async (id, patch, token) => {
    try {
        const res = await axios.patch(API_URL + API_KANBAN_FILTERS + id + '/', patch, getAuthConfig(token));
        return res.data;
    } catch (e) {
        console.error('APIUpdateKanbanFilter:', e);
        return null;
    }
};

export const APIDeleteKanbanFilter = async (id, token) => {
    try {
        const res = await axios.delete(API_URL + API_KANBAN_FILTERS + id + '/', getAuthConfig(token));
        return res.data;
    } catch (e) {
        console.error('APIDeleteKanbanFilter:', e);
        return null;
    }
};

// Перемещение события в целевую колонку.
// Без payload — «проба»: сервер может вернуть code:'data_required'.
export const APIKanbanMoveEvent = async (eventId, payload, token) => {
    try {
        const res = await axios.post(
            API_URL + API_KANBAN_EVENTS + `${eventId}/move/`,
            payload,
            getAuthConfig(token)
        );
        return res.data; // { status:'ok', stage, event }
    } catch (e) {
        // тело ошибки нужно фронту, чтобы распарсить data_required
        return e?.response?.data || { status: 'error', message: 'Ошибка перемещения' };
    }
};

// ── Управление чертёжником на стадии черчения (Задача 1) ──
const API_EVENT_DRAFTSMAN = '/main/api/events/';

// Назначить чертёжника событию, у которого его ещё нет
export const APIDraftsmanAssign = async (eventId, draftsmanId, token) => {
    try {
        const response = await axios.post(
            API_URL + API_EVENT_DRAFTSMAN + `${eventId}/draftsman/assign/`,
            { draftsman_id: draftsmanId },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIDraftsmanAssign:', error);
        return error?.response?.data || { status: 'error', message: 'Ошибка назначения чертёжника' };
    }
};

// Открепить текущего чертёжника
export const APIDraftsmanUnassign = async (eventId, reason = '', token) => {
    try {
        const response = await axios.post(
            API_URL + API_EVENT_DRAFTSMAN + `${eventId}/draftsman/unassign/`,
            { reason },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIDraftsmanUnassign:', error);
        return error?.response?.data || { status: 'error', message: 'Ошибка открепления чертёжника' };
    }
};

// Переназначить чертёжника. clearPreviousData=true — удалить данные прошлого (в т.ч. площадь);
// false — площадь прошлого переносится новому.
export const APIDraftsmanReassign = async (eventId, draftsmanId, clearPreviousData = false, token, confirmKonsolReplace = false) => {
    try {
        const response = await axios.post(
            API_URL + API_EVENT_DRAFTSMAN + `${eventId}/draftsman/reassign/`,
            { draftsman_id: draftsmanId, clear_previous_data: clearPreviousData,
              confirm_konsol_replace: confirmKonsolReplace },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APIDraftsmanReassign:', error);
        return error?.response?.data || { status: 'error', message: 'Ошибка переназначения чертёжника' };
    }
};

// ── Статус «Доработка» у события (Задача 3) ──
export const APISetEventRevision = async (eventId, on, comment = '', token) => {
    try {
        const response = await axios.post(
            API_URL + `/main/api/events/${eventId}/set-revision/`,
            { on, comment },
            getAuthConfig(token)
        );
        return response.data;
    } catch (error) {
        console.error('APISetEventRevision:', error);
        return error?.response?.data || { status: 'error', message: 'Ошибка смены статуса доработки' };
    }
};

// ── Статус «Доработка» у заявки (Задача 3) ──
export const APISetApplicationRevision = async (applicationId, on, comment = '', token) => {
    try {
        const response = await axios.post(
            API_URL + `/main/api/client/manager/applications/${applicationId}/set-revision/`,
            { on, comment },
            getAuthConfig(token)
        );
        return response.data; // { status, new_status, status_display }
    } catch (error) {
        console.error('APISetApplicationRevision:', error);
        return error?.response?.data || { status: 'error', message: 'Ошибка смены статуса доработки' };
    }
};


// ─── Новости (сторис) ─────────────────────────────────────────────────────────
const API_NEWS = '/main/api/news';

const newsAuthHeaders = (token, json = false) => {
    const authToken = token || getAuthToken();
    const headers = {};
    if (authToken) headers['Authorization'] = `Bearer ${authToken}`;
    if (json) headers['Content-Type'] = 'application/json';
    return headers;
};

/**
 * События просмотра шлём «в фоне»: ошибка сети не должна ломать проигрывание.
 * keepalive=true нужен для досыла времени при закрытии вкладки.
 */
const newsPost = async (path, body, token, keepalive = false) => {
    try {
        const response = await fetch(`${API_URL}${API_NEWS}${path}`, {
            method: 'POST',
            headers: newsAuthHeaders(token, true),
            body: JSON.stringify(body || {}),
            keepalive,
        });
        if (!response.ok) return null;
        return await response.json();
    } catch (e) {
        return null;
    }
};

// Лента новостей к показу «сегодня»
export const APIGetNewsFeed = async (token) => {
    try {
        const response = await fetch(`${API_URL}${API_NEWS}/feed/`, {
            headers: newsAuthHeaders(token),
        });
        if (!response.ok) return { count: 0, results: [] };
        return await response.json();
    } catch (e) {
        return { count: 0, results: [] };
    }
};

// Лента сторис для шапки: включает уже просмотренные (для пересмотра).
export const APINewsStories = async (token) => {
  try {
    const r = await axios.get(`${API_URL}/main/api/news/stories/`, getAuthConfig(token));
    return r.data; // { today, count, results:[...] }
  } catch (e) {
    console.error('APINewsStories', e);
    return { results: [] };
  }
};

// Лёгкая проверка «есть ли что показать» (без слайдов)
export const APIGetNewsUnseenCount = async (token) => {
    try {
        const response = await fetch(`${API_URL}${API_NEWS}/unseen-count/`, {
            headers: newsAuthHeaders(token),
        });
        if (!response.ok) return { count: 0, ids: [] };
        return await response.json();
    } catch (e) {
        return { count: 0, ids: [] };
    }
};

// Открытие новости в плеере.
// Плеер ждёт ответа перед первым событием слайда: иначе два параллельных
// запроса создают две строки просмотра (дубли в таблице зрителей).
export const APINewsOpen = (newsId, data, token) =>
    newsPost(`/${newsId}/open/`, data, token);

// Показ слайда. count_view=false — только досыл времени, без нового «показа»
export const APINewsSlideView = (slideId, data, token, keepalive = false) =>
    newsPost(`/slides/${slideId}/view/`, data, token, keepalive);

// Нажата кнопка «Ок» на последнем слайде
export const APINewsComplete = (newsId, data, token) =>
    newsPost(`/${newsId}/complete/`, data, token);

// Закрыл, не досмотрев
export const APINewsDismiss = (newsId, data, token, keepalive = false) =>
    newsPost(`/${newsId}/dismiss/`, data, token, keepalive);


// ─── Новости: административная часть ──────────────────────────────────────────

const newsJson = async (path, { method = 'GET', body = null, token } = {}) => {
    try {
        const response = await fetch(`${API_URL}${API_NEWS}${path}`, {
            method,
            headers: newsAuthHeaders(token, !!body),
            body: body ? JSON.stringify(body) : undefined,
        });
        if (response.status === 204) return { _deleted: true };
        const data = await response.json().catch(() => null);
        if (!response.ok) return { _error: true, _status: response.status, ...(data || {}) };
        return data;
    } catch (e) {
        console.error('[news api]', path, e);
        return { _error: true };
    }
};

// FormData: Content-Type выставляет браузер сам (нужен boundary)
const newsUpload = async (path, formData, token, method = 'POST') => {
    try {
        const response = await fetch(`${API_URL}${API_NEWS}${path}`, {
            method,
            headers: newsAuthHeaders(token),
            body: formData,
        });
        if (response.status === 204) return { _deleted: true };
        const data = await response.json().catch(() => null);
        if (!response.ok) return { _error: true, _status: response.status, ...(data || {}) };
        return data;
    } catch (e) {
        console.error('[news upload]', path, e);
        return { _error: true };
    }
};

// Справочники для селектов редактора
export const APIGetNewsAdminDictionaries = (token) =>
    newsJson('/admin/dictionaries/', { token });

// Список новостей (карточки + счётчики)
export const APIGetNewsAdminList = async (token, params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v !== null && v !== undefined && v !== '') qs.append(k, v);
    });
    const suffix = qs.toString() ? `?${qs}` : '';
    const data = await newsJson(`/admin/${suffix}`, { token });
    if (data?._error) return { count: 0, num_pages: 1, page: 1, results: [] };
    return data;
};

export const APIGetNewsAdminDetail = (id, token) =>
    newsJson(`/admin/${id}/`, { token });

export const APIGetNewsAdminPreview = (id, token) =>
    newsJson(`/admin/${id}/preview/`, { token });

export const APICreateNewsAdmin = (data, token) =>
    newsJson('/admin/create/', { method: 'POST', body: data, token });

export const APIUpdateNewsAdmin = (id, data, token) =>
    newsJson(`/admin/${id}/`, { method: 'PATCH', body: data, token });

export const APIDeleteNewsAdmin = (id, token) =>
    newsJson(`/admin/${id}/`, { method: 'DELETE', token });

export const APISetNewsAdminStatus = (id, status, token) =>
    newsJson(`/admin/${id}/status/`, { method: 'POST', body: { status }, token });

export const APIDuplicateNewsAdmin = (id, token) =>
    newsJson(`/admin/${id}/duplicate/`, { method: 'POST', body: {}, token });

export const APIUploadNewsCover = (id, file, token) => {
    const fd = new FormData();
    fd.append('file', file);
    return newsUpload(`/admin/${id}/cover/`, fd, token);
};

// ── Слайды ──
export const APICreateNewsSlide = (newsId, data, token) =>
    newsJson(`/admin/${newsId}/slides/create/`, { method: 'POST', body: data, token });

export const APIUpdateNewsSlide = (slideId, data, token) =>
    newsJson(`/admin/slides/${slideId}/`, { method: 'PATCH', body: data, token });

export const APIDeleteNewsSlide = (slideId, token) =>
    newsJson(`/admin/slides/${slideId}/`, { method: 'DELETE', token });

export const APIReorderNewsSlides = (newsId, orderIds, token) =>
    newsJson(`/admin/${newsId}/slides/reorder/`, { method: 'POST', body: { order: orderIds }, token });

export const APIUploadNewsSlideBackground = (slideId, file, token) => {
    const fd = new FormData();
    fd.append('file', file);
    return newsUpload(`/admin/slides/${slideId}/background/`, fd, token);
};

export const APIDeleteNewsSlideBackground = (slideId, token) =>
    newsJson(`/admin/slides/${slideId}/background/`, { method: 'DELETE', token });

export const APIUploadNewsSlideImages = (slideId, files, token) => {
    const fd = new FormData();
    [...files].forEach(f => fd.append('files', f));
    return newsUpload(`/admin/slides/${slideId}/images/`, fd, token);
};

export const APIUpdateNewsSlideImage = (imageId, data, token) =>
    newsJson(`/admin/slides/images/${imageId}/`, { method: 'PATCH', body: data, token });

export const APIDeleteNewsSlideImage = (imageId, token) =>
    newsJson(`/admin/slides/images/${imageId}/`, { method: 'DELETE', token });

// Картинка, вставляемая прямо в текст (WYSIWYG)
export const APIUploadNewsEditorImage = (file, token) => {
    const fd = new FormData();
    fd.append('file', file);
    return newsUpload('/admin/upload-image/', fd, token);
};

// ─── Новости: статистика ──────────────────────────────────────────────────────

const newsQuery = (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v !== null && v !== undefined && v !== '') qs.append(k, v);
    });
    return qs.toString() ? `?${qs}` : '';
};

// Сводка по всем новостям
export const APIGetNewsStatsSummary = async (token, params = {}) => {
    const data = await newsJson(`/admin/stats/${newsQuery(params)}`, { token });
    if (data?._error) return { totals: {}, results: [], period: {} };
    return data;
};

// Детальная статистика одной новости
export const APIGetNewsStatsDetail = (id, token, params = {}) =>
    newsJson(`/admin/${id}/stats/${newsQuery(params)}`, { token });

// Таблица зрителей
export const APIGetNewsViewers = async (id, token, params = {}) => {
    const data = await newsJson(`/admin/${id}/viewers/${newsQuery(params)}`, { token });
    if (data?._error) return { count: 0, num_pages: 1, page: 1, results: [] };
    return data;
};

// Кто из аудитории ещё не открыл
export const APIGetNewsNotViewed = async (id, token, params = {}) => {
    const data = await newsJson(`/admin/${id}/not-viewed/${newsQuery(params)}`, { token });
    if (data?._error) return { audience_total: 0, not_opened_total: 0, results: [], started_not_finished: [] };
    return data;
};

/**
 * Скачивание CSV. Обычная ссылка не подойдёт — нужен заголовок Authorization,
 * поэтому тянем blob и отдаём его через временный <a download>.
 */
export const APIDownloadNewsStatsCsv = async (id, token, params = {}) => {
    try {
        const response = await fetch(`${API_URL}${API_NEWS}/admin/${id}/stats/export/${newsQuery(params)}`, {
            headers: newsAuthHeaders(token),
        });
        if (!response.ok) return false;

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `news_${id}_viewers.csv`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return true;
    } catch (e) {
        console.error('[news csv]', e);
        return false;
    }
};

// Расхождения: у нас отмечено «выплачено», в Консоли задание не оплачено
export const APIKonsolMismatches = async (token, limit = 500) => {
    try {
        const r = await axios.get(`${API_URL}/data-statistic/finance/konsol/mismatches/`, {
            ...getAuthConfig(token),
            params: { limit },
        });
        return r.data; // { count, results: [...] }
    } catch (e) {
        console.error('APIKonsolMismatches:', e?.message || e);
        return { count: 0, results: [] };
    }
};

// Принудительная сверка статусов заданий с Консолью
export const APIKonsolReconcile = async (token, limit = 300) => {
    try {
        const r = await axios.post(
            `${API_URL}/data-statistic/finance/konsol/reconcile/`,
            { limit },
            getAuthConfig(token),
        );
        return r.data; // { status, stats }
    } catch (e) {
        console.error('APIKonsolReconcile:', e?.message || e);
        return { status: 'error', stats: null };
    }
};


// Досоздать чат по заявке (страховка, если чат почему-то не создался)
export const APIEnsureApplicationChat = async (applicationId, token) => {
    try {
        const r = await axios.post(
            API_URL + API_MANAGER_APPLICATIONS + `${applicationId}/ensure-chat/`,
            {}, getAuthConfig(token),
        );
        return r.data;
    } catch (e) {
        const detail = e?.response?.data?.detail;
        return { status: 'error', detail: typeof detail === 'string' ? detail : 'Не удалось открыть чат клиента' };
    }
};


// ─── Конструктор планов (изолированный модуль; эндпоинты из Этапа 1 сервера) ──
const API_CONSTRUCTOR = '/api/constructor/plans/';

export const APIConstructorListPlans = async () => {
  const res = await axios.get(API_URL + API_CONSTRUCTOR);
  return res.data;
};
export const APIConstructorGetPlan = async (uid) => {
  const res = await axios.get(API_URL + API_CONSTRUCTOR + uid + '/');
  return res.data;
};
export const APIConstructorCreatePlan = async (payload) => {
  const res = await axios.post(API_URL + API_CONSTRUCTOR, payload);
  return res.data;
};
export const APIConstructorUpdatePlan = async (uid, payload) => {
  const res = await axios.patch(API_URL + API_CONSTRUCTOR + uid + '/', payload);
  return res.data;
};
export const APIConstructorDeletePlan = async (uid) => {
  const res = await axios.delete(API_URL + API_CONSTRUCTOR + uid + '/');
  return res.data;
};
export const APIConstructorExportPdf = async (uid, payload) => {
  const res = await axios.post(API_URL + API_CONSTRUCTOR + uid + '/export-pdf/', payload, {
    responseType: 'blob',
  });
  return res.data; // Blob (application/pdf)
};
export const APIConstructorListPhotos = async (uid) => {
  const res = await axios.get(API_URL + API_CONSTRUCTOR + uid + '/photos/');
  return res.data;
};
export const APIConstructorUploadPhoto = async (uid, cameraId, file, heading = null, meta = null) => {
  const fd = new FormData();
  fd.append('photo', file, (file && file.name) || 'photo.jpg');
  fd.append('camera_id', cameraId);
  if (heading != null && heading !== '') fd.append('heading', String(heading));
  if (meta && typeof meta === 'object') {
    if (meta.pitch != null && meta.pitch !== '') fd.append('pitch', String(meta.pitch));
    if (meta.roll != null && meta.roll !== '') fd.append('roll', String(meta.roll));
    if (meta.source) fd.append('source', String(meta.source));
  }
  const res = await axios.post(API_URL + API_CONSTRUCTOR + uid + '/photos/', fd, { timeout: 120000 });
  return res.data;
};
export const APIConstructorDeletePhoto = async (uid, photoId) => {
  const res = await axios.delete(API_URL + API_CONSTRUCTOR + uid + '/photos/' + photoId + '/');
  return res.data;
};
export const APIConstructorPlanForEvent = async (eventId) => {
  const res = await axios.get(API_URL + '/api/constructor/plans/for-event/' + eventId + '/');
  return res.data;
};
export const APIConstructorEventContext = async (eventId) => {
  const res = await axios.get(API_URL + '/api/constructor/context/event/' + eventId + '/');
  return res.data;
};
export const APIConstructorAttachPdf = async (uid, payload) => {
  const res = await axios.post(API_URL + API_CONSTRUCTOR + uid + '/attach-to-application/', payload);
  return res.data;
};


// ═══════════════════════════════════════════════════════════════════
//  Логи действий (activity_log) — раздел «Логи» (руководитель/админ)
//  ВАЖНО: базовый путь должен совпадать с тем, как activity_log.urls
//  подключён в корневом urls.py бэкенда (Этап 1 → '/api/activity-logs/').
//  Если на бэке подключили под префиксом (напр. 'main/'), поправь строку ниже.
// ═══════════════════════════════════════════════════════════════════
const API_ACTIVITY_LOGS = '/api/activity-logs/';

// Список логов с фильтрами и пагинацией
export const APIActivityLogs = async (params = {}, token) => {
    const response = await axios.get(API_URL + API_ACTIVITY_LOGS, {
        ...getAuthConfig(token), params,
    });
    return response.data;
};

// Значения фильтров (модули/действия/уровни/статусы) + счётчики
export const APIActivityLogFacets = async (token) => {
    const response = await axios.get(API_URL + API_ACTIVITY_LOGS + 'facets/', getAuthConfig(token));
    return response.data;
};

// Агрегаты для графиков (таймлайн / по уровням / по модулям / по результату)
export const APIActivityLogStats = async (params = {}, token) => {
    const response = await axios.get(API_URL + API_ACTIVITY_LOGS + 'stats/', {
        ...getAuthConfig(token), params,
    });
    return response.data;
};

// Карточка одного лога (полные payload'ы: request/response/meta)
export const APIActivityLogDetail = async (id, token) => {
    const response = await axios.get(API_URL + API_ACTIVITY_LOGS + `${id}/`, getAuthConfig(token));
    return response.data;
};

// Экспорт текущего среза в JSON-файл (возвращает Blob)
export const APIActivityLogExport = async (params = {}, token) => {
    const response = await axios.get(API_URL + API_ACTIVITY_LOGS + 'export/', {
        ...getAuthConfig(token), params, responseType: 'blob',
    });
    return response.data;
};

// Создать короткий код доступа к срезу логов
export const APIActivityLogShareCreate = async (filters = {}, ttlHours = 72, token) => {
    const response = await axios.post(
        API_URL + API_ACTIVITY_LOGS + 'share/',
        { filters, ttl_hours: ttlHours },
        getAuthConfig(token),
    );
    return response.data;
};

// Прочитать срез логов по коду
export const APIActivityLogShareResolve = async (code, params = {}, token) => {
    const response = await axios.get(
        API_URL + API_ACTIVITY_LOGS + `share/${code}/`,
        { ...getAuthConfig(token), params },
    );
    return response.data;
};


// ── Управление доступом (права/роли) ──
const API_ACCESS = '/main/api/access';

export const APIAccessPermissions = async (token) => {
    try { const r = await axios.get(`${API_URL}${API_ACCESS}/permissions/`, getAuthConfig(token)); return r.data; }
    catch (e) { console.error(e); return e?.response?.data || { groups: [] }; }
};
export const APIAccessRoles = async (token) => {
    try { const r = await axios.get(`${API_URL}${API_ACCESS}/roles/`, getAuthConfig(token)); return r.data; }
    catch (e) { console.error(e); return e?.response?.data || { roles: [] }; }
};
export const APIAccessRoleCreate = async (payload, token) => {
    try { const r = await axios.post(`${API_URL}${API_ACCESS}/roles/create/`, payload, getAuthConfig(token)); return r.data; }
    catch (e) { console.error(e); return e?.response?.data || { status: 'error', message: 'Ошибка' }; }
};
export const APIAccessRoleUpdate = async (id, payload, token) => {
    try { const r = await axios.patch(`${API_URL}${API_ACCESS}/roles/${id}/`, payload, getAuthConfig(token)); return r.data; }
    catch (e) { console.error(e); return e?.response?.data || { status: 'error', message: 'Ошибка' }; }
};
export const APIAccessRoleDelete = async (id, token) => {
    try { const r = await axios.delete(`${API_URL}${API_ACCESS}/roles/${id}/delete/`, getAuthConfig(token)); return r.data; }
    catch (e) { console.error(e); return e?.response?.data || { status: 'error', message: 'Ошибка' }; }
};
export const APIAccessEmployees = async (q, token) => {
    try { const r = await axios.get(`${API_URL}${API_ACCESS}/employees/${q ? `?q=${encodeURIComponent(q)}` : ''}`, getAuthConfig(token)); return r.data; }
    catch (e) { console.error(e); return e?.response?.data || { employees: [] }; }
};
export const APIAccessEmployeeSetRoles = async (id, roleIds, scope, token) => {
    try {
        const r = await axios.post(
            `${API_URL}${API_ACCESS}/employees/${id}/roles/`,
            { role_ids: roleIds, access_scope: scope },
            getAuthConfig(token)
        );
        return r.data;
    } catch (e) { console.error(e); return e?.response?.data || { status: 'error', message: 'Ошибка' }; }
};

export const APIMyPermissions = async (token) => {
    try { const r = await axios.get(`${API_URL}/main/api/access/me/permissions/`, getAuthConfig(token)); return r.data; }
    catch (e) {
        const status = e?.response?.status;
        return { _error: true, _status: status, _isAuthError: status === 401 || status === 403 };
    }
};


// ══════════════════════════════════════════════════════════════
//  ДОКУМЕНТЫ (модуль документооборота)
//  Префикс из корневого urlconf (Этап 3): path('documents/', include('documents.urls'))
// ══════════════════════════════════════════════════════════════
export const API_DOCUMENTS = '/documents/';
const API_MANAGER_CLIENTS = '/main/api/client/manager/clients/';
const API_SELLER_BASE = '/main/api/client/';

// Публичная ссылка на PDF (открытие в новой вкладке, без токена)
export const documentSharedUrl = (shareToken) =>
    `${API_URL}${API_DOCUMENTS}shared/${shareToken}/`;

export const APIDocumentsList = async (params = {}, token) => {
    try {
        const r = await axios.get(API_URL + API_DOCUMENTS, { ...getAuthConfig(token), params });
        return r.data;               // { total, count, results: [...] }
    } catch (e) { console.error('APIDocumentsList', e?.message); return null; }
};

export const APIDocumentDetail = async (id, token) => {
    try {
        const r = await axios.get(API_URL + API_DOCUMENTS + `${id}/`, getAuthConfig(token));
        return r.data;
    } catch (e) { console.error('APIDocumentDetail', e?.message); return null; }
};

export const APIGenerateDocument = async (payload, token) => {
    try {
        const r = await axios.post(API_URL + API_DOCUMENTS + 'generate/', payload, getAuthConfig(token));
        return r.data;
    } catch (e) { return e?.response?.data || { status: 'error', message: 'Ошибка генерации' }; }
};

export const APIRegenerateDocument = async (id, token) => {
    try {
        const r = await axios.post(API_URL + API_DOCUMENTS + `${id}/regenerate/`, {}, getAuthConfig(token));
        return r.data;
    } catch (e) { return e?.response?.data || { status: 'error', message: 'Ошибка' }; }
};

export const APIDeliverDocument = async (id, payload, token) => {
    try {
        const r = await axios.post(API_URL + API_DOCUMENTS + `${id}/deliver/`, payload, getAuthConfig(token));
        return r.data;
    } catch (e) { return e?.response?.data || { status: 'error', message: 'Ошибка отправки' }; }
};

export const APISetDocumentStatus = async (id, statusValue, token) => {
    try {
        const r = await axios.post(API_URL + API_DOCUMENTS + `${id}/status/`, { status: statusValue }, getAuthConfig(token));
        return r.data;
    } catch (e) { return e?.response?.data || { status: 'error', message: 'Ошибка' }; }
};

export const APIGenerateDocumentBundle = async (payload, token) => {
    try {
        const r = await axios.post(API_URL + API_DOCUMENTS + 'bundle/', payload, getAuthConfig(token));
        return r.data;
    } catch (e) { return e?.response?.data || { status: 'error', message: 'Ошибка' }; }
};

// ── Реквизиты клиента (менеджерская правка, Этап 2) ──
export const APIManagerClientDetail = async (id, token) => {
    try {
        const r = await axios.get(API_URL + API_MANAGER_CLIENTS + `${id}/`, getAuthConfig(token));
        return r.data;
    } catch (e) { console.error('APIManagerClientDetail', e?.message); return null; }
};

export const APIManagerClientUpdate = async (id, payload, token) => {
    try {
        const r = await axios.patch(API_URL + API_MANAGER_CLIENTS + `${id}/update/`, payload, getAuthConfig(token));
        return r.data;
    } catch (e) { return e?.response?.data || { status: 'error', message: 'Ошибка сохранения' }; }
};

// ── Реквизиты исполнителя (Этап 2) ──
export const APISellerDefault = async (token) => {
    try {
        const r = await axios.get(API_URL + API_SELLER_BASE + 'seller/default/', getAuthConfig(token));
        return r.data;
    } catch (e) { return null; }
};




// ===== Вспомогательные функции =====

// Обработка ошибок API
const handleApiError = (error) => {
  if (error.code === 'ECONNABORTED') {
    console.error('Запрос превысил лимит ожидания.');
  } else if (error.code === 'ERR_NETWORK') {
    console.error('Ошибка сети.');
  } else if (error.response) {
    // Ошибка с ответом от сервера
    console.error('Ошибка сервера:', error.response.status, error.response.data);
  } else {
    console.error('Произошла ошибка:', error.message);
  }
};

// Создание конфигурации axios с токеном авторизации
export const getAuthConfig = (token) => ({
  headers: {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
});




// const API_POST_LOGIN = '/api/login/'
// // Запрос авторизации
// export const APIPostLogin = async () => {
//   try {
//     const response = await axios.get(API_URL + API_POST_LOGIN);
//     return response.data;
//   } catch (error) {
//     console.log(error);
//     if (error.code === 'ECONNABORTED') {
//       console.error('Запрос превысил лимит ожидания.');
//       return error;
//     } 
//     if (error.code === 'ERR_NETWORK') {
//       console.error('Ошибка сети.');
//       return error;
//     } else {
//       console.error('Произошла ошибка:', error.message);
//       return error;
//     }
//   }
// };



// const API_AUTH_USER = '/account/login/'
// // Запрос авторизации
// export const APIAuthUser = async (email, pwd) => {
//   // Импортируем приватный ключ как CryptoKey
//   const privateKey = await importPKCS8(privateKeyPEM, 'RS256');
//   // Генерация токена
//   const token = await new SignJWT({ email: email, password: pwd })
//   .setProtectedHeader({ alg: 'RS256' })  // Алгоритм подписи
//   // .setIssuedAt() // Устанавливаем время выпуска
//   .sign(privateKey); // Подпись токена
//   // console.log(token);

//   try {
//     const response = await axios.post(API_URL + API_AUTH_USER, { token });
//     return response.data;
//   } catch (error) {
//     console.log(error);
//     if (error.code === 'ECONNABORTED') {
//       console.error('Запрос превысил лимит ожидания.');
//       return error;
//     } 
//     if (error.code === 'ERR_NETWORK') {
//       console.error('Ошибка сети.');
//       return error;
//     } else {
//       console.error('Произошла ошибка:', error.message);
//       return error;
//     }
//   }
// };




// const API_GET_USER = '/account/get-user/'
// // Запрос получить пользователя
// export const APIGetUser = async () => {

//   try {
//     const authToken = Cookies.get('authToken');
//     const response = await axios.get(API_URL + API_GET_USER, {
//       headers: {
//         Authorization: authToken,  // Передача токена в заголовке
//       }
//     });
//     return response.data;
//   } catch (error) {
//     console.log(error);
//     if (error.code === 'ECONNABORTED') {
//       console.error('Запрос превысил лимит ожидания.');
//       return error;
//     } 
//     if (error.code === 'ERR_NETWORK') {
//       console.error('Ошибка сети.');
//       return error;
//     } else {
//       console.error('Произошла ошибка:', error.message);
//       return error;
//     }
//   }
// };





export const APIDispatchCancel = async (dispatchId, broadcastStartedAt, token) => {
    try {
        const r = await axios.post(`${API_URL}${API_DISPATCH}/${dispatchId}/cancel/`,
            { broadcast_started_at: broadcastStartedAt }, getAuthConfig(token));
        return r.data;
    } catch (e) { return { status: 'error', message: dispatchError(e?.response?.data) || e?.message }; }
};

export const APICancelSurveyorUpload = async (processId, token) => {
    try {
        const r = await axios.post(`${API_URL}/main/api/surveyor/completion/${processId}/cancel/`, {}, getAuthConfig(token));
        return r.data;
    } catch (e) { return { status: 'error', message: dispatchError(e?.response?.data) || e?.message }; }
};


export const APIAdditionalMeasurement = async (eventId, { reason, files = [], request_key, surveyor_id, date, time, time_from, time_to }, token) => {
  const data = new FormData();
  data.append('reason', reason); data.append('request_key', request_key);
  Object.entries({ surveyor_id, date, time, time_from, time_to }).forEach(([key, value]) => { if (value != null) data.append(key, value); });
  files.forEach(file => data.append('files', file));
  try {
    const result = await axios.post(`${API_URL}/main/api/quality/events/${eventId}/additional-measurement/`, data,
      { headers: { Authorization: `Bearer ${token}` } });
    return result.data;
  } catch (error) {
    return { status: 'error', message: dispatchError(error?.response?.data) || 'Ошибка связи' };
  }
};


export const APIRetryDelivery = async (eventId, token) => {
  try {
    const response = await axios.post(`${API_URL}/main/api/events/${eventId}/delivery/retry/`, {}, getAuthConfig(token));
    return response.data;
  } catch (error) {
    return { status: 'error', message: dispatchError(error?.response?.data || error) };
  }
};


export const APIGetDraftsmanStatistics = async (params, token) => {
  const response = await axios.get(`${API_URL}/main/api/draftsman/me/statistics/`, {
    ...getAuthConfig(token), params,
  });
  return response.data;
};


const drawingRecoveryRequest = async (method, eventId, data, token) => {
    try {
        const response = await axios({
            method, url: `${API_URL}/main/api/events/${eventId}/drawing-recovery/`,
            ...getAuthConfig(token), data,
        });
        return response.data;
    } catch (error) {
        const detail = error.response?.data;
        const text = detail?.message || detail?.detail || (Array.isArray(detail) ? detail.join(' ') : null);
        throw new Error(typeof text === 'string' ? text : 'Ошибка связи с сервером. Повторите проверку.');
    }
};
export const APIDrawingRecovery = (eventId, token) => drawingRecoveryRequest('get', eventId, undefined, token);
export const APIReopenDrawing = (eventId, data, token) => drawingRecoveryRequest('post', eventId, data, token);

export const APIKonsolEventLinkTask = async (eventId, role, taskId, token) => {
  try {
    const result = await axios.post(`${API_URL}/data-statistic/konsol/events/${eventId}/task/${role}/link/`,
      { task_id: Number(taskId) }, getAuthConfig(token));
    return result.data;
  } catch (e) { return e?.response?.data || { status: 'error', message: 'Не удалось сверить задание' }; }
};


// Отдельный документ платформенного задания; автоматической оплаты здесь нет.
export const APIKonsolDocument = async (paymentId, role, body = null) => {
  try {
    const url = `${API_URL}/data-statistic/payments/${paymentId}/konsol/task/${role}/document/`;
    const response = body ? await axios.post(url, body) : await axios.get(url);
    return response.data;
  } catch (error) {
    const data = error?.response?.data;
    return { status: 'error', message: String(data?.message || data?.detail || data?.error || error?.message || 'Ошибка документа') };
  }
};
// Ручная корректировка завершения: предварительный просмотр и подтверждение версии.
export const APIManualCompletionPreview = async (eventId, token) => {
  try {
    return (await axios.get(`${API_URL}/main/api/events/${eventId}/manual-completion/`, getAuthConfig(token))).data;
  } catch (error) {
    return { ...normalizeApiError(error, 'Не удалось загрузить состояние события'), status: 'error' };
  }
};
export const APIManualCompleteEvent = async (eventId, data, token) => {
  try {
    return (await axios.post(`${API_URL}/main/api/events/${eventId}/manual-completion/`, data, getAuthConfig(token))).data;
  } catch (error) {
    return { ...normalizeApiError(error, 'Не удалось завершить событие'), status: 'error' };
  }
};
